(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Colelection-product-grid-lorcana"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Colelection-product-grid-yugi"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid-magic"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▼';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid-single"] && !window.DesignMode) return;
  try {
    
const a0_0x586fdb=a0_0x2091;(function(_0x1e43d3,_0x1a4007){const _0x20d3e9=a0_0x2091,_0x6f6d54=_0x1e43d3();while(!![]){try{const _0x1e398d=parseInt(_0x20d3e9(0x281))/0x1*(parseInt(_0x20d3e9(0x1c7))/0x2)+-parseInt(_0x20d3e9(0x2c6))/0x3+parseInt(_0x20d3e9(0x276))/0x4+parseInt(_0x20d3e9(0x1eb))/0x5+-parseInt(_0x20d3e9(0x18e))/0x6+-parseInt(_0x20d3e9(0x2cc))/0x7*(parseInt(_0x20d3e9(0x1ec))/0x8)+parseInt(_0x20d3e9(0x274))/0x9;if(_0x1e398d===_0x1a4007)break;else _0x6f6d54['push'](_0x6f6d54['shift']());}catch(_0x586f25){_0x6f6d54['push'](_0x6f6d54['shift']());}}}(a0_0x3226,0xe1ef1),window['POKEMON_DEBUG']=![]);function debugLog(..._0x429a1f){const _0xd896d6=a0_0x2091;window[_0xd896d6(0x21d)]&&console[_0xd896d6(0x2de)](..._0x429a1f);}function debugWarn(..._0xa7e17b){const _0xd1d639=a0_0x2091;window[_0xd1d639(0x21d)]&&console[_0xd1d639(0x1e8)](..._0xa7e17b);}function debugError(..._0x3b2695){const _0x1753a5=a0_0x2091;window['POKEMON_DEBUG']&&console[_0x1753a5(0x1b1)](..._0x3b2695);}class CollectionManager{constructor(){const _0x4175ee=a0_0x2091;this[_0x4175ee(0x279)]=new FilterManager(),this[_0x4175ee(0x1a6)]=new CartManager(),this[_0x4175ee(0x1a0)]=new PokemonImageManager(),this['initializeButtons']();}[a0_0x586fdb(0x1ab)](){const _0x16b484=a0_0x586fdb;document[_0x16b484(0x237)]('.product-button')['forEach'](_0x228151=>{new ProductButton(_0x228151);});}}class PokemonImageManager{constructor(){const _0x3c1b6e=a0_0x586fdb;this[_0x3c1b6e(0x26c)]=window[_0x3c1b6e(0x266)]||'',this[_0x3c1b6e(0x271)]=_0x3c1b6e(0x253),this[_0x3c1b6e(0x256)]=0x3,this[_0x3c1b6e(0x28f)]();}[a0_0x586fdb(0x28f)](){const _0x4eccb8=a0_0x586fdb,_0x14f6bb=new IntersectionObserver(_0xce98e8=>{const _0x2d6564=a0_0x2091;_0xce98e8[_0x2d6564(0x207)](_0x32a359=>{const _0x2f709e=_0x2d6564;if(_0x32a359['isIntersecting']){const _0x24d3ea=_0x32a359[_0x2f709e(0x1a2)];if(_0x24d3ea[_0x2f709e(0x244)](_0x2f709e(0x245))===_0x2f709e(0x2b3)){_0x24d3ea['dataset'][_0x2f709e(0x216)]=_0x2f709e(0x17e);return;}_0x24d3ea[_0x2f709e(0x190)][_0x2f709e(0x23c)](_0x2f709e(0x1ef))&&!_0x24d3ea[_0x2f709e(0x1a3)][_0x2f709e(0x216)]&&this[_0x2f709e(0x204)](_0x24d3ea);}});},{'rootMargin':'50px'});document[_0x4eccb8(0x237)]('.pokemon-card-image')['forEach'](_0x2953b2=>{const _0xfa83fe=_0x4eccb8;_0x14f6bb[_0xfa83fe(0x1e5)](_0x2953b2);});}async[a0_0x586fdb(0x204)](_0x245116){const _0x3f2e6b=a0_0x586fdb,_0x1b369f=_0x245116['dataset'][_0x3f2e6b(0x2a2)],_0x1c3310=_0x245116[_0x3f2e6b(0x1a3)][_0x3f2e6b(0x1fa)],_0x4206e0=_0x245116[_0x3f2e6b(0x1a3)][_0x3f2e6b(0x1ea)],_0x5c33f8=_0x245116['dataset'][_0x3f2e6b(0x1b4)],_0x4ced30=_0x245116['dataset'][_0x3f2e6b(0x2e8)],_0x5881e2=_0x245116['dataset']['energia'],_0x133a7d=_0x245116['dataset'][_0x3f2e6b(0x26f)];let _0x38fa8e='';const _0x51b5d9=_0x1c3310[_0x3f2e6b(0x1e6)](/#(\d+)/);if(_0x51b5d9)_0x38fa8e=_0x51b5d9[0x1];if(!_0x1b369f&&!_0x1c3310)return;_0x245116['dataset'][_0x3f2e6b(0x216)]='loading';const _0xce7a5c=_0x245116['parentElement']['querySelector'](_0x3f2e6b(0x215));if(_0xce7a5c)_0xce7a5c[_0x3f2e6b(0x1cb)][_0x3f2e6b(0x17d)]='flex';try{let _0x2be4f3={'cardId':_0x1b369f,'productTitle':_0x1c3310,'set':_0x4206e0,'numero':_0x38fa8e,'rareza':_0x5c33f8,'idioma':_0x4ced30,'energia':_0x5881e2,'tipo':_0x133a7d};if(_0x1b369f){const _0x493c93=await this[_0x3f2e6b(0x218)](_0x1b369f);_0x493c93&&(_0x2be4f3={'cardId':_0x493c93['id']||_0x1b369f,'productTitle':_0x493c93[_0x3f2e6b(0x1f2)]||_0x1c3310,'set':_0x493c93[_0x3f2e6b(0x1ea)]&&_0x493c93[_0x3f2e6b(0x1ea)]['id']?_0x493c93[_0x3f2e6b(0x1ea)]['id']:_0x4206e0,'numero':_0x493c93[_0x3f2e6b(0x1da)]||_0x38fa8e,'rareza':_0x493c93['rarity']||_0x5c33f8,'idioma':_0x4ced30,'energia':_0x5881e2,'tipo':_0x133a7d});}if(window[_0x3f2e6b(0x1ca)]){const _0x178c36=await window[_0x3f2e6b(0x1ca)]['getImage'](_0x2be4f3,this['imageSize']);_0x178c36&&(_0x245116['src']=_0x178c36,_0x245116['dataset'][_0x3f2e6b(0x216)]='true');}else debugWarn(_0x3f2e6b(0x29c));}catch(_0x5393b5){debugError(_0x3f2e6b(0x19a),_0x5393b5),_0x245116[_0x3f2e6b(0x1a3)]['pokemonLoaded']='error';}finally{if(_0xce7a5c)_0xce7a5c[_0x3f2e6b(0x1cb)]['display']=_0x3f2e6b(0x258);}}async['fetchTCGdexCard'](_0x570be6){const _0x5a5009=a0_0x586fdb;try{const _0x1d5089=_0x5a5009(0x2db)+_0x570be6,_0x2414de=await fetch(_0x1d5089);if(!_0x2414de['ok'])return null;const _0x3d67bd=await _0x2414de[_0x5a5009(0x1f3)]();if(_0x3d67bd&&_0x3d67bd['id'])return _0x3d67bd;return null;}catch(_0x59786f){return debugWarn('Error\x20fetching\x20TCGdex\x20card:',_0x59786f),null;}}}class FilterManager{constructor(){const _0x239608=a0_0x586fdb;this[_0x239608(0x2bc)]=document[_0x239608(0x2e6)](_0x239608(0x1e9)),this['filterGroups']=document[_0x239608(0x237)](_0x239608(0x278)),this['filterInputs']=document[_0x239608(0x237)]('.filter-option\x20input'),this[_0x239608(0x2c4)]=document['querySelector'](_0x239608(0x19e)),this[_0x239608(0x233)]=document[_0x239608(0x2e6)]('.per-page-select'),this[_0x239608(0x2bd)]=Array[_0x239608(0x1d0)](document['querySelectorAll'](_0x239608(0x1b3))),this['init']();}['init'](){const _0x18512c=a0_0x586fdb;this[_0x18512c(0x1bd)](),this['setupFilterInputs'](),this[_0x18512c(0x2b8)](),this['setupPerPage'](),this['initMobileSidebar'](),this[_0x18512c(0x19d)](),this[_0x18512c(0x1b5)](),this[_0x18512c(0x172)](),this[_0x18512c(0x22c)](),this[_0x18512c(0x201)](),setInterval(()=>{document['visibilityState']==='visible'&&location['reload']();},0x493e0);}['restorePokemonFilterState'](){}['initMobileSidebar'](){const _0x27cc4d=a0_0x586fdb,_0x1a3135=document[_0x27cc4d(0x1a4)](_0x27cc4d(0x2a1));_0x1a3135[_0x27cc4d(0x29f)]='filter-toggle-button',_0x1a3135['innerHTML']=_0x27cc4d(0x1ae),document[_0x27cc4d(0x205)][_0x27cc4d(0x273)](_0x1a3135);const _0x48f7f8=document[_0x27cc4d(0x1a4)](_0x27cc4d(0x20c));_0x48f7f8[_0x27cc4d(0x29f)]=_0x27cc4d(0x2c8),document[_0x27cc4d(0x205)]['appendChild'](_0x48f7f8);const _0x90e32d=document['createElement']('div');_0x90e32d[_0x27cc4d(0x29f)]='sidebar-header',_0x90e32d[_0x27cc4d(0x1c6)]=_0x27cc4d(0x1fd);const _0x2b0394=document['querySelector'](_0x27cc4d(0x225));_0x2b0394[_0x27cc4d(0x2ba)](_0x90e32d,_0x2b0394[_0x27cc4d(0x1a1)]),_0x1a3135[_0x27cc4d(0x1ce)](_0x27cc4d(0x261),()=>this[_0x27cc4d(0x221)](!![])),_0x48f7f8[_0x27cc4d(0x1ce)]('click',()=>this[_0x27cc4d(0x221)](![])),_0x90e32d['querySelector'](_0x27cc4d(0x2cd))['addEventListener'](_0x27cc4d(0x261),()=>this['toggleSidebar'](![])),window[_0x27cc4d(0x249)]<=0x3df&&this[_0x27cc4d(0x211)][_0x27cc4d(0x207)](_0x19ce13=>{const _0x51cacb=_0x27cc4d;_0x19ce13[_0x51cacb(0x1ce)]('change',()=>{const _0x1a48b2=_0x51cacb;setTimeout(()=>this[_0x1a48b2(0x221)](![]),0x12c);});});}[a0_0x586fdb(0x221)](_0x45e5c7){const _0x1e11da=a0_0x586fdb,_0x1ee84d=document[_0x1e11da(0x2e6)](_0x1e11da(0x225)),_0x3ee8b8=document[_0x1e11da(0x2e6)](_0x1e11da(0x1a7));_0x45e5c7?(_0x1ee84d[_0x1e11da(0x190)][_0x1e11da(0x20d)](_0x1e11da(0x189)),_0x3ee8b8[_0x1e11da(0x190)][_0x1e11da(0x20d)](_0x1e11da(0x189)),document[_0x1e11da(0x205)][_0x1e11da(0x190)]['add']('sidebar-open')):(_0x1ee84d['classList'][_0x1e11da(0x186)](_0x1e11da(0x189)),_0x3ee8b8['classList'][_0x1e11da(0x186)](_0x1e11da(0x189)),document[_0x1e11da(0x205)]['classList'][_0x1e11da(0x186)]('sidebar-open'));}[a0_0x586fdb(0x1bd)](){const _0x3b89da=a0_0x586fdb;this[_0x3b89da(0x1c4)][_0x3b89da(0x207)](_0x48a605=>{const _0x414a81=_0x3b89da,_0x113308=_0x48a605['querySelector'](_0x414a81(0x181)),_0x352ff2=_0x48a605['querySelector'](_0x414a81(0x227)),_0x12a599=_0x113308[_0x414a81(0x2e6)](_0x414a81(0x2d3));_0x352ff2[_0x414a81(0x190)][_0x414a81(0x20d)](_0x414a81(0x189)),_0x12a599[_0x414a81(0x1cf)]='▲',_0x113308[_0x414a81(0x1ce)](_0x414a81(0x261),()=>{const _0x2f12b6=_0x414a81,_0x419542=_0x352ff2['classList'][_0x2f12b6(0x23c)]('active');_0x419542?(_0x352ff2[_0x2f12b6(0x190)]['remove'](_0x2f12b6(0x189)),_0x12a599[_0x2f12b6(0x1cf)]='▼'):(_0x352ff2[_0x2f12b6(0x190)][_0x2f12b6(0x20d)](_0x2f12b6(0x189)),_0x12a599[_0x2f12b6(0x1cf)]='▲');});});}[a0_0x586fdb(0x1cd)](){const _0xaec029=a0_0x586fdb;this[_0xaec029(0x211)][_0xaec029(0x207)](_0x550acc=>{const _0x41d0e0=_0xaec029;_0x550acc[_0x41d0e0(0x1ce)]('change',()=>this[_0x41d0e0(0x222)]());}),this['setupPokemonSearch']();}[a0_0x586fdb(0x22c)](){const _0x1104c9=a0_0x586fdb,_0xdf0f19=document[_0x1104c9(0x1f5)](_0x1104c9(0x1ac)),_0x500a32=document[_0x1104c9(0x1f5)](_0x1104c9(0x27d)),_0x5bf11d=document['getElementById'](_0x1104c9(0x29d)),_0x41ca17=document[_0x1104c9(0x1f5)]('search-type-filter'),_0x1fa2b1=document[_0x1104c9(0x1f5)]('search-rarity-filter'),_0x1ea67f=document[_0x1104c9(0x1f5)](_0x1104c9(0x29a)),_0x564720=document['getElementById'](_0x1104c9(0x2ce)),_0x5a9fd4=document[_0x1104c9(0x1f5)](_0x1104c9(0x1f4)),_0x11c302=()=>{const _0x379155=_0x1104c9,_0x38f391=_0xdf0f19['value'][_0x379155(0x229)]()[_0x379155(0x200)](),_0x2c4964=_0x41ca17[_0x379155(0x2c2)],_0x2f59ed=_0x1fa2b1[_0x379155(0x2c2)],_0x585659=_0x1ea67f['value'],_0x218a04=_0x564720[_0x379155(0x2c2)],_0x4ef78f=_0x5a9fd4[_0x379155(0x2c2)];let _0x17062a=0x0;this[_0x379155(0x2bd)][_0x379155(0x207)](_0x5268f0=>{const _0x5705bb=_0x379155;let _0x3b1713=!![];const _0x4615e7=_0x5268f0[_0x5705bb(0x244)](_0x5705bb(0x191))?.[_0x5705bb(0x200)]()||'';if(_0x38f391&&!_0x4615e7[_0x5705bb(0x17a)](_0x38f391))_0x3b1713=![];const _0x2fba16=_0x5268f0[_0x5705bb(0x244)]('data-energia')||_0x5268f0['dataset'][_0x5705bb(0x2bb)];if(_0x2c4964&&_0x2fba16!==_0x2c4964)_0x3b1713=![];const _0x1f9f7b=_0x5268f0['getAttribute'](_0x5705bb(0x243))||_0x5268f0[_0x5705bb(0x1a3)][_0x5705bb(0x1b4)];if(_0x2f59ed&&_0x1f9f7b!==_0x2f59ed)_0x3b1713=![];const _0x4055a3=_0x5268f0[_0x5705bb(0x244)](_0x5705bb(0x196))||_0x5268f0[_0x5705bb(0x1a3)][_0x5705bb(0x1ea)];if(_0x585659&&_0x4055a3!==_0x585659)_0x3b1713=![];const _0x27fd0b=_0x5268f0[_0x5705bb(0x244)](_0x5705bb(0x26a))||_0x5268f0[_0x5705bb(0x1a3)]['tipo']||'';if(_0x4ef78f&&_0x27fd0b[_0x5705bb(0x200)]()!==_0x4ef78f['toLowerCase']())_0x3b1713=![];const _0x5bc4d7=_0x5268f0[_0x5705bb(0x244)]('data-idioma')||_0x5268f0[_0x5705bb(0x1a3)]['idioma']||'';if(_0x218a04&&_0x5bc4d7!==_0x218a04)_0x3b1713=![];_0x3b1713?(_0x5268f0[_0x5705bb(0x1a3)][_0x5705bb(0x176)]='true',_0x17062a++):(_0x5268f0[_0x5705bb(0x1a3)][_0x5705bb(0x176)]=_0x5705bb(0x2b3),_0x5268f0[_0x5705bb(0x1cb)][_0x5705bb(0x17d)]=_0x5705bb(0x258));}),this['updatePagination'](_0x17062a);};if(_0xdf0f19)_0xdf0f19['addEventListener']('input',_0x11c302);if(_0x41ca17)_0x41ca17[_0x1104c9(0x1ce)](_0x1104c9(0x28b),_0x11c302);if(_0x1fa2b1)_0x1fa2b1[_0x1104c9(0x1ce)](_0x1104c9(0x28b),_0x11c302);if(_0x1ea67f)_0x1ea67f[_0x1104c9(0x1ce)]('change',_0x11c302);if(_0x564720)_0x564720[_0x1104c9(0x1ce)](_0x1104c9(0x28b),_0x11c302);if(_0x5a9fd4)_0x5a9fd4[_0x1104c9(0x1ce)](_0x1104c9(0x28b),_0x11c302);if(_0x500a32)_0x500a32[_0x1104c9(0x1ce)](_0x1104c9(0x261),_0x11c302);if(_0x5bf11d)_0x5bf11d['addEventListener']('click',()=>{const _0x25fdbf=_0x1104c9;if(_0xdf0f19)_0xdf0f19[_0x25fdbf(0x2c2)]='';if(_0x41ca17)_0x41ca17[_0x25fdbf(0x2c2)]='';if(_0x1fa2b1)_0x1fa2b1[_0x25fdbf(0x2c2)]='';if(_0x1ea67f)_0x1ea67f['value']='';if(_0x564720)_0x564720[_0x25fdbf(0x2c2)]='';if(_0x5a9fd4)_0x5a9fd4[_0x25fdbf(0x2c2)]='';setTimeout(_0x11c302,0x64);});}[a0_0x586fdb(0x195)](_0xbe38e){const _0x19d03a=a0_0x586fdb,_0x302a02=0x14,_0x331bbb=Math[_0x19d03a(0x21a)](_0xbe38e/_0x302a02),_0x23c258=document['getElementById'](_0x19d03a(0x2af)),_0x2031bf=document[_0x19d03a(0x1f5)](_0x19d03a(0x2aa)),_0x1c040d=document[_0x19d03a(0x1f5)](_0x19d03a(0x2a3)),_0x4359da=document[_0x19d03a(0x1f5)](_0x19d03a(0x1c2));console[_0x19d03a(0x2de)](_0x19d03a(0x2c9),{'visibleCount':_0xbe38e,'totalPages':_0x331bbb,'itemsPerPage':_0x302a02});if(_0x331bbb<=0x1){_0x23c258[_0x19d03a(0x1cb)][_0x19d03a(0x17d)]=_0x19d03a(0x258),console[_0x19d03a(0x2de)](_0x19d03a(0x2b6)),this['showAllVisibleProducts']();return;}_0x23c258[_0x19d03a(0x1cb)][_0x19d03a(0x17d)]=_0x19d03a(0x248),this[_0x19d03a(0x283)]=0x1,this[_0x19d03a(0x230)]=_0xbe38e,this['itemsPerPage']=_0x302a02,console[_0x19d03a(0x2de)]('🔍\x20Configurando\x20paginación:',{'currentPage':this['currentPage'],'totalVisibleItems':this['totalVisibleItems'],'itemsPerPage':this[_0x19d03a(0x2d1)]}),this[_0x19d03a(0x213)]();}[a0_0x586fdb(0x28a)](){const _0x36f312=a0_0x586fdb;let _0x586f47=0x0;this[_0x36f312(0x2bd)][_0x36f312(0x207)](_0x39e5f5=>{const _0x54fa65=_0x36f312;_0x39e5f5['dataset']['filtered']===_0x54fa65(0x254)&&(_0x39e5f5[_0x54fa65(0x1cb)][_0x54fa65(0x17d)]='',_0x586f47++);}),console[_0x36f312(0x2de)](_0x36f312(0x26b),_0x586f47);}[a0_0x586fdb(0x213)](){const _0x4d313b=a0_0x586fdb,_0x5b52f2=Math[_0x4d313b(0x21a)](this[_0x4d313b(0x230)]/this['itemsPerPage']),_0x62afb2=document[_0x4d313b(0x1f5)]('pagination-info'),_0x4691b4=document['getElementById'](_0x4d313b(0x2a3)),_0x326023=document[_0x4d313b(0x1f5)](_0x4d313b(0x1c2));_0x62afb2[_0x4d313b(0x1cf)]=_0x4d313b(0x22b)+this['currentPage']+_0x4d313b(0x17c)+_0x5b52f2,_0x4691b4['disabled']=this['currentPage']===0x1,_0x326023['disabled']=this['currentPage']===_0x5b52f2,this['showPage'](this[_0x4d313b(0x283)],this[_0x4d313b(0x230)]);}[a0_0x586fdb(0x1f7)](_0x4b499d,_0x59e5d3){const _0x878ca0=a0_0x586fdb,_0xda3354=(_0x4b499d-0x1)*this['itemsPerPage'],_0x11af3e=Math[_0x878ca0(0x2c7)](_0xda3354+this[_0x878ca0(0x2d1)],_0x59e5d3);console['log'](_0x878ca0(0x23e),{'page':_0x4b499d,'startIndex':_0xda3354,'endIndex':_0x11af3e,'totalVisible':_0x59e5d3});let _0x372321=0x0,_0x20b2d8=0x0;this[_0x878ca0(0x2bd)][_0x878ca0(0x207)](_0x182622=>{const _0x1b708a=_0x878ca0;_0x182622[_0x1b708a(0x1a3)][_0x1b708a(0x176)]!==_0x1b708a(0x2b3)&&(_0x372321>=_0xda3354&&_0x372321<_0x11af3e?(_0x182622['style'][_0x1b708a(0x17d)]='',_0x20b2d8++):_0x182622[_0x1b708a(0x1cb)][_0x1b708a(0x17d)]=_0x1b708a(0x258),_0x372321++);}),console[_0x878ca0(0x2de)](_0x878ca0(0x247),_0x20b2d8);}[a0_0x586fdb(0x234)](){const _0x3b7248=a0_0x586fdb,_0x8bc009=Math[_0x3b7248(0x21a)](this[_0x3b7248(0x230)]/this['itemsPerPage']);this[_0x3b7248(0x283)]<_0x8bc009&&(this['currentPage']++,this['updatePaginationDisplay']());}['prevPage'](){const _0x32ec16=a0_0x586fdb;this[_0x32ec16(0x283)]>0x1&&(this[_0x32ec16(0x283)]--,this[_0x32ec16(0x213)]());}[a0_0x586fdb(0x201)](){const _0x2c1ef4=a0_0x586fdb,_0x173e0c=document[_0x2c1ef4(0x1f5)](_0x2c1ef4(0x2a3)),_0x2326e9=document[_0x2c1ef4(0x1f5)](_0x2c1ef4(0x1c2));_0x173e0c&&_0x173e0c[_0x2c1ef4(0x1ce)]('click',()=>this['prevPage']()),_0x2326e9&&_0x2326e9['addEventListener'](_0x2c1ef4(0x261),()=>this[_0x2c1ef4(0x234)]()),this[_0x2c1ef4(0x2bd)][_0x2c1ef4(0x207)](_0x5595df=>{const _0x427ab8=_0x2c1ef4;_0x5595df[_0x427ab8(0x1a3)]['filtered']=_0x427ab8(0x254);}),console[_0x2c1ef4(0x2de)](_0x2c1ef4(0x28c),this['productCards'][_0x2c1ef4(0x1f9)]),console[_0x2c1ef4(0x2de)](_0x2c1ef4(0x289),this[_0x2c1ef4(0x2bd)][_0x2c1ef4(0x1d3)](_0x43d89c=>_0x43d89c[_0x2c1ef4(0x1a3)][_0x2c1ef4(0x176)]===_0x2c1ef4(0x254))['length']),this[_0x2c1ef4(0x1b5)](),this[_0x2c1ef4(0x195)](this[_0x2c1ef4(0x2bd)][_0x2c1ef4(0x1f9)]);}[a0_0x586fdb(0x238)](_0x50b7a8){const _0x4fcc6f=a0_0x586fdb,_0x2156a0=_0x50b7a8[_0x4fcc6f(0x1a2)][_0x4fcc6f(0x2c2)]['trim'](),_0x524315=document[_0x4fcc6f(0x1f5)]('search-suggestions');if(_0x2156a0[_0x4fcc6f(0x1f9)]<0x2){_0x524315[_0x4fcc6f(0x1cb)][_0x4fcc6f(0x17d)]=_0x4fcc6f(0x258);return;}const _0x3952a3=this[_0x4fcc6f(0x2a5)](_0x2156a0);this['showSuggestions'](_0x3952a3);}['generateSuggestions'](_0x21729f){const _0x591465=a0_0x586fdb,_0x398b45=[],_0x69a52e=_0x21729f[_0x591465(0x200)](),_0x224038=[_0x591465(0x177),_0x591465(0x18c),_0x591465(0x1df),_0x591465(0x2b5),_0x591465(0x259),_0x591465(0x28e),_0x591465(0x194),_0x591465(0x2cf),'Metal','Psychic',_0x591465(0x255)];_0x224038['forEach'](_0x3a0d30=>{const _0x5e73e2=_0x591465;_0x3a0d30['toLowerCase']()[_0x5e73e2(0x17a)](_0x69a52e)&&_0x398b45[_0x5e73e2(0x1ee)]({'text':_0x5e73e2(0x19c)+_0x3a0d30,'value':_0x3a0d30,'category':_0x5e73e2(0x294)});});const _0x5200c3=[_0x591465(0x24d),_0x591465(0x292),_0x591465(0x24e),_0x591465(0x25e),_0x591465(0x1e0),_0x591465(0x1f0)];_0x5200c3['forEach'](_0x38f482=>{const _0x4eaeae=_0x591465;_0x38f482[_0x4eaeae(0x200)]()[_0x4eaeae(0x17a)](_0x69a52e)&&_0x398b45[_0x4eaeae(0x1ee)]({'text':_0x4eaeae(0x27c)+_0x38f482,'value':_0x38f482,'category':_0x4eaeae(0x262)});});const _0x3d6318=[_0x591465(0x20f),_0x591465(0x2d4),_0x591465(0x224),_0x591465(0x1bc),_0x591465(0x20e),_0x591465(0x1be),_0x591465(0x184),_0x591465(0x20a),'XY',_0x591465(0x257),'Sword\x20&\x20Shield','Scarlet\x20&\x20Violet'];_0x3d6318['forEach'](_0x220b25=>{const _0x5af161=_0x591465;_0x220b25[_0x5af161(0x200)]()[_0x5af161(0x17a)](_0x69a52e)&&_0x398b45[_0x5af161(0x1ee)]({'text':_0x5af161(0x260)+_0x220b25,'value':_0x220b25,'category':_0x5af161(0x23d)});});const _0x16c09f=[{'code':'es','name':_0x591465(0x208)},{'code':'en','name':_0x591465(0x2ad)},{'code':'fr','name':'Francés'},{'code':'de','name':'Alemán'},{'code':'it','name':_0x591465(0x2b7)},{'code':'pt','name':'Portugués'},{'code':'ja','name':_0x591465(0x1fb)},{'code':'ko','name':_0x591465(0x1d6)},{'code':'zh','name':'Chino'}];_0x16c09f['forEach'](_0x49035b=>{const _0x4eb577=_0x591465;(_0x49035b[_0x4eb577(0x1f2)][_0x4eb577(0x200)]()[_0x4eb577(0x17a)](_0x69a52e)||_0x49035b[_0x4eb577(0x25f)][_0x4eb577(0x200)]()[_0x4eb577(0x17a)](_0x69a52e))&&_0x398b45[_0x4eb577(0x1ee)]({'text':'Idioma:\x20'+_0x49035b[_0x4eb577(0x1f2)],'value':_0x49035b[_0x4eb577(0x25f)],'category':_0x4eb577(0x183)});});const _0x578be5=[_0x591465(0x285),_0x591465(0x21e),_0x591465(0x19f),_0x591465(0x2e3),_0x591465(0x287),_0x591465(0x23f),_0x591465(0x235)];return _0x578be5[_0x591465(0x207)](_0x50bc8c=>{const _0x126a9e=_0x591465;_0x50bc8c[_0x126a9e(0x200)]()[_0x126a9e(0x17a)](_0x69a52e)&&_0x398b45[_0x126a9e(0x1ee)]({'text':_0x50bc8c,'value':_0x50bc8c,'category':_0x126a9e(0x1f2)});}),_0x398b45[_0x591465(0x2b9)](0x0,0x8);}['showSuggestions'](_0x121b90){const _0xb9106e=a0_0x586fdb,_0x1bae48=document[_0xb9106e(0x1f5)](_0xb9106e(0x192));if(_0x121b90[_0xb9106e(0x1f9)]===0x0){_0x1bae48[_0xb9106e(0x1cb)][_0xb9106e(0x17d)]=_0xb9106e(0x258);return;}_0x1bae48[_0xb9106e(0x1c6)]=_0x121b90[_0xb9106e(0x1fe)](_0x275f87=>'<div\x20class=\x22search-suggestion-item\x22\x20data-value=\x22'+_0x275f87[_0xb9106e(0x2c2)]+_0xb9106e(0x179)+_0x275f87[_0xb9106e(0x2e4)]+_0xb9106e(0x2d8)+_0x275f87[_0xb9106e(0x203)]+_0xb9106e(0x188))[_0xb9106e(0x2df)](''),_0x1bae48['style'][_0xb9106e(0x17d)]='block',_0x1bae48['querySelectorAll'](_0xb9106e(0x1e3))['forEach'](_0x31ac14=>{const _0x7d5442=_0xb9106e;_0x31ac14[_0x7d5442(0x1ce)](_0x7d5442(0x261),()=>{const _0x1d1c39=_0x7d5442,_0x4aa7ff=_0x31ac14['dataset'][_0x1d1c39(0x2c2)],_0x41e0fd=_0x31ac14[_0x1d1c39(0x1a3)][_0x1d1c39(0x2e4)];if(_0x41e0fd===_0x1d1c39(0x294))document[_0x1d1c39(0x1f5)](_0x1d1c39(0x299))[_0x1d1c39(0x2c2)]=_0x4aa7ff;else{if(_0x41e0fd===_0x1d1c39(0x262))document[_0x1d1c39(0x1f5)](_0x1d1c39(0x288))[_0x1d1c39(0x2c2)]=_0x4aa7ff;else{if(_0x41e0fd===_0x1d1c39(0x23d))document['getElementById'](_0x1d1c39(0x29a))['value']=_0x4aa7ff;else{if(_0x41e0fd===_0x1d1c39(0x183))document[_0x1d1c39(0x1f5)](_0x1d1c39(0x2ce))[_0x1d1c39(0x2c2)]=_0x4aa7ff;else _0x41e0fd==='name'?document['getElementById'](_0x1d1c39(0x1ac))[_0x1d1c39(0x2c2)]=_0x4aa7ff:document['getElementById']('pokemon-search-input')[_0x1d1c39(0x2c2)]=_0x4aa7ff;}}}_0x1bae48[_0x1d1c39(0x1cb)][_0x1d1c39(0x17d)]=_0x1d1c39(0x258),this['performSearch']();});});}['performSearch'](){const _0x201ad4=a0_0x586fdb,_0x12cd85=document['getElementById'](_0x201ad4(0x1ac))['value'][_0x201ad4(0x229)](),_0x3750f1=document[_0x201ad4(0x1f5)](_0x201ad4(0x299))[_0x201ad4(0x2c2)],_0x44d0ad=document[_0x201ad4(0x1f5)](_0x201ad4(0x288))[_0x201ad4(0x2c2)],_0xa8afb3=document[_0x201ad4(0x1f5)]('search-expansion-filter')[_0x201ad4(0x2c2)],_0x1dfcb2=document['getElementById'](_0x201ad4(0x2ce))[_0x201ad4(0x2c2)],_0x5e6713=document[_0x201ad4(0x1f5)]('search-cardtype-filter')['value'],_0x2fe45e=new URL(window[_0x201ad4(0x19b)][_0x201ad4(0x21c)]);_0x2fe45e[_0x201ad4(0x1d7)]['delete'](_0x201ad4(0x1ba)),_0x2fe45e[_0x201ad4(0x1d7)][_0x201ad4(0x22e)](_0x201ad4(0x1c5)),_0x2fe45e[_0x201ad4(0x1d7)][_0x201ad4(0x22e)]('pokemon_rarity'),_0x2fe45e['searchParams']['delete'](_0x201ad4(0x22d)),_0x2fe45e['searchParams'][_0x201ad4(0x22e)]('pokemon_language'),_0x2fe45e[_0x201ad4(0x1d7)][_0x201ad4(0x22e)]('pokemon_cardtype'),_0x12cd85&&_0x2fe45e[_0x201ad4(0x1d7)][_0x201ad4(0x1ea)]('pokemon_search',_0x12cd85),_0x3750f1&&_0x2fe45e['searchParams'][_0x201ad4(0x1ea)](_0x201ad4(0x1c5),_0x3750f1),_0x44d0ad&&_0x2fe45e[_0x201ad4(0x1d7)]['set'](_0x201ad4(0x2da),_0x44d0ad),_0xa8afb3&&_0x2fe45e['searchParams'][_0x201ad4(0x1ea)](_0x201ad4(0x22d),_0xa8afb3),_0x1dfcb2&&_0x2fe45e[_0x201ad4(0x1d7)]['set'](_0x201ad4(0x1a8),_0x1dfcb2),_0x5e6713&&_0x2fe45e[_0x201ad4(0x1d7)][_0x201ad4(0x1ea)](_0x201ad4(0x29b),_0x5e6713),localStorage[_0x201ad4(0x1c0)](_0x201ad4(0x193),JSON[_0x201ad4(0x2dd)]({'query':_0x12cd85,'type':_0x3750f1,'rarity':_0x44d0ad,'expansion':_0xa8afb3,'language':_0x1dfcb2,'cardtype':_0x5e6713})),window[_0x201ad4(0x19b)]=_0x2fe45e[_0x201ad4(0x1f1)]();}[a0_0x586fdb(0x182)](){const _0x4ff6eb=a0_0x586fdb;document['getElementById'](_0x4ff6eb(0x1ac))[_0x4ff6eb(0x2c2)]='',document[_0x4ff6eb(0x1f5)](_0x4ff6eb(0x299))[_0x4ff6eb(0x2c2)]='',document['getElementById'](_0x4ff6eb(0x288))[_0x4ff6eb(0x2c2)]='',document[_0x4ff6eb(0x1f5)](_0x4ff6eb(0x29a))[_0x4ff6eb(0x2c2)]='',document['getElementById']('search-language-filter')[_0x4ff6eb(0x2c2)]='',document[_0x4ff6eb(0x1f5)](_0x4ff6eb(0x1f4))[_0x4ff6eb(0x2c2)]='',document['getElementById']('search-suggestions')[_0x4ff6eb(0x1cb)][_0x4ff6eb(0x17d)]=_0x4ff6eb(0x258),localStorage['removeItem'](_0x4ff6eb(0x193));const _0x46b627=new URL(window['location']['href']);_0x46b627['searchParams']['delete'](_0x4ff6eb(0x1ba)),_0x46b627[_0x4ff6eb(0x1d7)][_0x4ff6eb(0x22e)](_0x4ff6eb(0x1c5)),_0x46b627[_0x4ff6eb(0x1d7)][_0x4ff6eb(0x22e)](_0x4ff6eb(0x2da)),_0x46b627[_0x4ff6eb(0x1d7)]['delete'](_0x4ff6eb(0x22d)),_0x46b627[_0x4ff6eb(0x1d7)][_0x4ff6eb(0x22e)](_0x4ff6eb(0x1a8)),_0x46b627['searchParams'][_0x4ff6eb(0x22e)](_0x4ff6eb(0x29b)),window[_0x4ff6eb(0x19b)]=_0x46b627[_0x4ff6eb(0x1f1)]();}[a0_0x586fdb(0x269)](){const _0xc2466a=a0_0x586fdb;try{const _0x2fccc6=localStorage[_0xc2466a(0x1bf)](_0xc2466a(0x193));if(_0x2fccc6){const _0x4153b0=JSON[_0xc2466a(0x1d1)](_0x2fccc6);_0x4153b0[_0xc2466a(0x24c)]&&(document['getElementById'](_0xc2466a(0x1ac))['value']=_0x4153b0['query']),_0x4153b0[_0xc2466a(0x294)]&&(document[_0xc2466a(0x1f5)](_0xc2466a(0x299))['value']=_0x4153b0[_0xc2466a(0x294)]),_0x4153b0[_0xc2466a(0x262)]&&(document[_0xc2466a(0x1f5)](_0xc2466a(0x288))['value']=_0x4153b0[_0xc2466a(0x262)]),_0x4153b0[_0xc2466a(0x23d)]&&(document['getElementById'](_0xc2466a(0x29a))[_0xc2466a(0x2c2)]=_0x4153b0[_0xc2466a(0x23d)]),_0x4153b0[_0xc2466a(0x183)]&&(document['getElementById'](_0xc2466a(0x2ce))[_0xc2466a(0x2c2)]=_0x4153b0[_0xc2466a(0x183)]),_0x4153b0[_0xc2466a(0x290)]&&(document[_0xc2466a(0x1f5)]('search-cardtype-filter')[_0xc2466a(0x2c2)]=_0x4153b0['cardtype']);}}catch(_0x1a8723){console[_0xc2466a(0x1e8)](_0xc2466a(0x23a),_0x1a8723);}}[a0_0x586fdb(0x2b8)](){const _0x248ada=a0_0x586fdb;this[_0x248ada(0x2c4)]&&this[_0x248ada(0x2c4)]['addEventListener']('change',_0x5d86f7=>{const _0x50d5d2=_0x248ada,_0x5386c7=new URL(window[_0x50d5d2(0x19b)][_0x50d5d2(0x21c)]);_0x5386c7['searchParams'][_0x50d5d2(0x1ea)](_0x50d5d2(0x1b9),_0x5d86f7['target'][_0x50d5d2(0x2c2)]),window[_0x50d5d2(0x19b)]=_0x5386c7[_0x50d5d2(0x1f1)]();});}[a0_0x586fdb(0x25d)](){const _0x377319=a0_0x586fdb;this[_0x377319(0x233)]&&this[_0x377319(0x233)][_0x377319(0x1ce)](_0x377319(0x28b),_0x20fba6=>{const _0x54f914=_0x377319,_0x3ec35f=new URL(window['location'][_0x54f914(0x21c)]);_0x3ec35f['searchParams'][_0x54f914(0x1ea)](_0x54f914(0x1a5),_0x20fba6[_0x54f914(0x1a2)]['value']),window['location']=_0x3ec35f[_0x54f914(0x1f1)]();});}[a0_0x586fdb(0x222)](){const _0xb11016=a0_0x586fdb,_0x559e0f=new FormData(this[_0xb11016(0x2bc)]),_0x4cb410=new URL(window['location'][_0xb11016(0x21c)]);[..._0x4cb410[_0xb11016(0x1d7)]['keys']()][_0xb11016(0x207)](_0x5be632=>{const _0x523945=_0xb11016;_0x5be632[_0x523945(0x1f8)](_0x523945(0x220))&&_0x4cb410[_0x523945(0x1d7)][_0x523945(0x22e)](_0x5be632);});for(let [_0x12d992,_0x31c5b9]of _0x559e0f[_0xb11016(0x295)]()){_0x4cb410[_0xb11016(0x1d7)][_0xb11016(0x2be)](_0x12d992,_0x31c5b9);}const _0x241052=_0x4cb410[_0xb11016(0x1d7)][_0xb11016(0x1d4)](_0xb11016(0x1b9)),_0x10d125=_0x4cb410[_0xb11016(0x1d7)][_0xb11016(0x1d4)]('view');if(_0x241052)_0x4cb410[_0xb11016(0x1d7)]['set']('sort_by',_0x241052);if(_0x10d125)_0x4cb410[_0xb11016(0x1d7)][_0xb11016(0x1ea)](_0xb11016(0x1a5),_0x10d125);window[_0xb11016(0x19b)]=_0x4cb410[_0xb11016(0x1f1)]();}[a0_0x586fdb(0x172)](){const _0x25c779=a0_0x586fdb,_0x2e1b48=new Set();this[_0x25c779(0x2bd)]['forEach'](_0xc07cf9=>{const _0x27558b=_0x25c779,_0x2c5aab=_0xc07cf9[_0x27558b(0x244)]('data-idioma')||_0xc07cf9[_0x27558b(0x1a3)][_0x27558b(0x2e8)];if(_0x2c5aab)_0x2e1b48[_0x27558b(0x20d)](_0x2c5aab);});const _0x1b979e=document[_0x25c779(0x1f5)]('search-language-filter');_0x1b979e&&(_0x1b979e['innerHTML']='<option\x20value=\x22\x22>Todos\x20los\x20idiomas</option>',Array['from'](_0x2e1b48)[_0x25c779(0x2a9)]()[_0x25c779(0x207)](_0x59ca99=>{const _0x1ec580=_0x25c779,_0x57f0a1=document[_0x1ec580(0x1a4)]('option');_0x57f0a1[_0x1ec580(0x2c2)]=_0x59ca99,_0x57f0a1[_0x1ec580(0x1cf)]=_0x59ca99,_0x1b979e[_0x1ec580(0x273)](_0x57f0a1);}));}['populateExpansionFilter'](){const _0x3904ad=a0_0x586fdb,_0x3d4d7b=document[_0x3904ad(0x1f5)]('search-expansion-filter');if(!_0x3d4d7b)return;_0x3d4d7b[_0x3904ad(0x1c6)]=_0x3904ad(0x241);const _0xd0778e=new Set();this[_0x3904ad(0x2bd)][_0x3904ad(0x207)](_0x3a4653=>{const _0x43967f=_0x3904ad,_0x357d7c=_0x3a4653[_0x43967f(0x244)]('data-set')||_0x3a4653[_0x43967f(0x1a3)][_0x43967f(0x1ea)];_0x357d7c&&_0x357d7c[_0x43967f(0x229)]()!==''&&_0xd0778e[_0x43967f(0x20d)](_0x357d7c[_0x43967f(0x229)]());}),Array['from'](_0xd0778e)['sort']()[_0x3904ad(0x207)](_0x1a6b85=>{const _0x3d0a63=_0x3904ad,_0x30f73f=document[_0x3d0a63(0x1a4)](_0x3d0a63(0x1dd));_0x30f73f[_0x3d0a63(0x2c2)]=_0x1a6b85,_0x30f73f[_0x3d0a63(0x1cf)]=_0x1a6b85,_0x3d4d7b[_0x3d0a63(0x273)](_0x30f73f);}),console[_0x3904ad(0x2de)](_0x3904ad(0x2a6),Array[_0x3904ad(0x1d0)](_0xd0778e)[_0x3904ad(0x2a9)]());}}class ProductButton{constructor(_0x527bdf){const _0x8aa2aa=a0_0x586fdb;this[_0x8aa2aa(0x2a1)]=_0x527bdf,this[_0x8aa2aa(0x18f)]=_0x527bdf[_0x8aa2aa(0x1a3)][_0x8aa2aa(0x18f)],this[_0x8aa2aa(0x282)]=_0x527bdf[_0x8aa2aa(0x1a3)][_0x8aa2aa(0x282)],this[_0x8aa2aa(0x214)]=_0x527bdf[_0x8aa2aa(0x1a3)]['action'],this[_0x8aa2aa(0x1de)]=_0x527bdf[_0x8aa2aa(0x1cf)],this[_0x8aa2aa(0x1a9)]();}['init'](){const _0x16b85b=a0_0x586fdb;this[_0x16b85b(0x2a1)][_0x16b85b(0x1ce)](_0x16b85b(0x261),()=>this['handleClick']());}async[a0_0x586fdb(0x263)](){const _0x2eb89d=a0_0x586fdb;if(this[_0x2eb89d(0x2a1)][_0x2eb89d(0x2d6)])return;try{this[_0x2eb89d(0x2e0)](!![]),this[_0x2eb89d(0x214)]==='preorder'?await this[_0x2eb89d(0x1e7)]():await this['handleAddToCart'](),this[_0x2eb89d(0x297)](),CartManager['updateCart']();}catch(_0x5933f8){debugError('Error:',_0x5933f8),this['showError']();}}async[a0_0x586fdb(0x1ed)](){const _0x3df05f=a0_0x586fdb,_0xfea86a=await fetch(_0x3df05f(0x240),{'method':'POST','headers':{'Content-Type':_0x3df05f(0x268)},'body':JSON[_0x3df05f(0x2dd)]({'items':[{'id':this[_0x3df05f(0x18f)],'quantity':0x1}]})});if(!_0xfea86a['ok'])throw new Error(_0x3df05f(0x22f));}async[a0_0x586fdb(0x1e7)](){const _0x537705=a0_0x586fdb,_0x2c5ba7=await fetch(_0x537705(0x240),{'method':_0x537705(0x2bf),'headers':{'Content-Type':_0x537705(0x268)},'body':JSON[_0x537705(0x2dd)]({'items':[{'id':this['productId'],'quantity':0x1,'properties':{'_preorder':!![],'Estimated\x20Shipping':'Pre-order\x20-\x202-3\x20semanas','Pre-order':_0x537705(0x1b8)}}]})});if(!_0x2c5ba7['ok'])throw new Error(_0x537705(0x1ad));}[a0_0x586fdb(0x2e0)](_0x3ed305){const _0x32e7e1=a0_0x586fdb;this[_0x32e7e1(0x2a1)][_0x32e7e1(0x231)]=_0x3ed305,this[_0x32e7e1(0x2a1)][_0x32e7e1(0x190)]['toggle'](_0x32e7e1(0x22a),_0x3ed305),this[_0x32e7e1(0x2a1)][_0x32e7e1(0x1cf)]=_0x3ed305?_0x32e7e1(0x2d7):this[_0x32e7e1(0x1de)];}[a0_0x586fdb(0x297)](){const _0x1acf40=a0_0x586fdb,_0x27f946=this['action']==='preorder'?'Pre-orden\x20agregada':_0x1acf40(0x210);this[_0x1acf40(0x2a1)][_0x1acf40(0x1cf)]=_0x27f946,setTimeout(()=>{const _0x17c46f=_0x1acf40;this['button'][_0x17c46f(0x2d6)]=![],this[_0x17c46f(0x2a1)][_0x17c46f(0x1cf)]=this[_0x17c46f(0x1de)];},0x7d0);}[a0_0x586fdb(0x219)](){const _0xb0dac0=a0_0x586fdb;this[_0xb0dac0(0x2a1)]['textContent']=_0xb0dac0(0x2c5),setTimeout(()=>{const _0x2f02fe=_0xb0dac0;this[_0x2f02fe(0x2a1)][_0x2f02fe(0x2d6)]=![],this[_0x2f02fe(0x2a1)][_0x2f02fe(0x1cf)]=this['originalText'];},0x7d0);}}class CartManager{static async[a0_0x586fdb(0x2e2)](){const _0x3e747e=a0_0x586fdb;try{const _0x1bc810=await fetch('/cart.js'),_0x496d5d=await _0x1bc810['json']();document[_0x3e747e(0x2ca)](new CustomEvent(_0x3e747e(0x171),{'detail':{'cart':_0x496d5d}}));}catch(_0x106a0e){debugError(_0x3e747e(0x264),_0x106a0e);}}}document['addEventListener'](a0_0x586fdb(0x1aa),function(){const _0x1748d8=a0_0x586fdb,_0x382d18=document[_0x1748d8(0x2e6)](_0x1748d8(0x1e9)),_0x519f7b=document[_0x1748d8(0x237)](_0x1748d8(0x239));_0x519f7b[_0x1748d8(0x207)](_0x977fed=>{const _0x483f6b=_0x1748d8;_0x977fed['addEventListener'](_0x483f6b(0x1ff),function(){const _0x1d2a08=_0x483f6b;if(this[_0x1d2a08(0x2c2)]<0x0)this[_0x1d2a08(0x2c2)]=0x0;});}),document['querySelector'](_0x1748d8(0x2d2))?.[_0x1748d8(0x1ce)](_0x1748d8(0x261),function(_0x52274f){const _0x462530=_0x1748d8;_0x52274f[_0x462530(0x291)](),_0x382d18[_0x462530(0x275)]();});});function a0_0x2091(_0x39e8ee,_0x2b3099){const _0x322655=a0_0x3226();return a0_0x2091=function(_0x2091f7,_0x4b4bd3){_0x2091f7=_0x2091f7-0x171;let _0x19a0ba=_0x322655[_0x2091f7];return _0x19a0ba;},a0_0x2091(_0x39e8ee,_0x2b3099);}class PokemonCardImageLoader{constructor(){const _0xf1cd6=a0_0x586fdb;this[_0xf1cd6(0x26c)]=window[_0xf1cd6(0x178)]||'',this[_0xf1cd6(0x180)]='https://api.pokemontcg.io/v2',this['imageSize']=window[_0xf1cd6(0x242)]||_0xf1cd6(0x173),this[_0xf1cd6(0x1b2)]=new Map(),this[_0xf1cd6(0x2dc)]=new Set(),this[_0xf1cd6(0x1a9)]();}[a0_0x586fdb(0x1a9)](){const _0xce4e=a0_0x586fdb;this[_0xce4e(0x1e2)]();}async[a0_0x586fdb(0x1e2)](){const _0x52d1bf=a0_0x586fdb,_0x3b2c2d=document[_0x52d1bf(0x237)](_0x52d1bf(0x2c0));_0x3b2c2d['forEach'](async _0xacae88=>{const _0x135f5b=_0x52d1bf;if(this[_0x135f5b(0x2dc)]['has'](_0xacae88))return;const _0x583af3=this[_0x135f5b(0x251)](_0xacae88);if(!_0x583af3)return;const _0x41106c=this[_0x135f5b(0x1b6)](_0x583af3);if(this[_0x135f5b(0x1b2)][_0x135f5b(0x27f)](_0x41106c)){this[_0x135f5b(0x29e)](_0xacae88,this['cache']['get'](_0x41106c));return;}const _0x292eaf=localStorage[_0x135f5b(0x1bf)](_0x135f5b(0x2a8)+_0x41106c);if(_0x292eaf){this[_0x135f5b(0x1b2)][_0x135f5b(0x1ea)](_0x41106c,_0x292eaf),this['updateImage'](_0xacae88,_0x292eaf);return;}await this[_0x135f5b(0x24f)](_0xacae88,_0x583af3,_0x41106c);});}[a0_0x586fdb(0x251)](_0x794745){const _0x5b6e4d=a0_0x586fdb,_0x183a24=_0x794745[_0x5b6e4d(0x1a3)][_0x5b6e4d(0x1fa)],_0xc3358=_0x794745['dataset'][_0x5b6e4d(0x1b4)],_0x3dcf1e=_0x794745[_0x5b6e4d(0x1a3)]['energia'],_0x281dfc=_0x794745[_0x5b6e4d(0x1a3)][_0x5b6e4d(0x1ea)],_0x44afe9=_0x794745[_0x5b6e4d(0x1a3)][_0x5b6e4d(0x2e8)],_0x2f6f77=_0x794745[_0x5b6e4d(0x1a3)]['tipo'],_0xe3e88a=_0x794745[_0x5b6e4d(0x1a3)][_0x5b6e4d(0x2a2)];if(!_0x183a24)return null;return{'title':_0x183a24['trim'](),'rareza':_0xc3358||'','energia':_0x3dcf1e||'','set':_0x281dfc||'','idioma':_0x44afe9||'','tipo':_0x2f6f77||'','cardId':_0xe3e88a||''};}[a0_0x586fdb(0x1b6)](_0x122055){const _0xfd3b84=a0_0x586fdb;return(_0x122055[_0xfd3b84(0x298)]+'_'+_0x122055[_0xfd3b84(0x1b4)]+'_'+_0x122055['energia']+'_'+_0x122055[_0xfd3b84(0x1ea)]+'_'+_0x122055[_0xfd3b84(0x2e8)]+'_'+_0x122055[_0xfd3b84(0x26f)])[_0xfd3b84(0x200)]()[_0xfd3b84(0x1f6)](/\s+/g,'_');}async[a0_0x586fdb(0x24f)](_0x468342,_0xb762fd,_0x538b7a){const _0x1c93f9=a0_0x586fdb;if(this[_0x1c93f9(0x2dc)]['has'](_0x468342))return;this['loadingCards']['add'](_0x468342),console['log'](_0x1c93f9(0x1fc),_0xb762fd),this[_0x1c93f9(0x175)](_0x468342);try{let _0x1f9c04=await this['trySearch'](_0xb762fd,!![]);(!_0x1f9c04||!_0x1f9c04[_0x1c93f9(0x198)]||_0x1f9c04[_0x1c93f9(0x198)][_0x1c93f9(0x1f9)]===0x0)&&(console['log'](_0x1c93f9(0x1e1)),_0x1f9c04=await this[_0x1c93f9(0x1c1)](_0xb762fd,![]));if(_0x1f9c04&&_0x1f9c04[_0x1c93f9(0x198)]&&_0x1f9c04[_0x1c93f9(0x198)][_0x1c93f9(0x1f9)]>0x0){console[_0x1c93f9(0x2de)]('✅\x20Encontradas\x20'+_0x1f9c04[_0x1c93f9(0x198)][_0x1c93f9(0x1f9)]+'\x20cartas');const _0x418993=this[_0x1c93f9(0x1c8)](_0x1f9c04[_0x1c93f9(0x198)],_0xb762fd);console['log'](_0x1c93f9(0x27a),_0x418993?_0x418993[_0x1c93f9(0x1f2)]:'No\x20encontrada');if(_0x418993&&_0x418993[_0x1c93f9(0x185)]&&_0x418993[_0x1c93f9(0x185)][this[_0x1c93f9(0x271)]]){const _0x2c7e77=_0x418993[_0x1c93f9(0x185)][this[_0x1c93f9(0x271)]];console[_0x1c93f9(0x2de)](_0x1c93f9(0x1db),_0x2c7e77),this['cache'][_0x1c93f9(0x1ea)](_0x538b7a,_0x2c7e77),localStorage[_0x1c93f9(0x1c0)](_0x1c93f9(0x2a8)+_0x538b7a,_0x2c7e77),this[_0x1c93f9(0x29e)](_0x468342,_0x2c7e77);}else console[_0x1c93f9(0x1b1)](_0x1c93f9(0x1d8),this['imageSize']),console[_0x1c93f9(0x2de)](_0x1c93f9(0x1dc),_0x418993?Object[_0x1c93f9(0x24b)](_0x418993[_0x1c93f9(0x185)]||{}):_0x1c93f9(0x2ab)),this[_0x1c93f9(0x219)](_0x468342);}else console[_0x1c93f9(0x1b1)]('❌\x20No\x20se\x20encontraron\x20cartas\x20en\x20la\x20API\x20después\x20de\x20intentos\x20múltiples'),this[_0x1c93f9(0x219)](_0x468342);}catch(_0x2050b2){console['error'](_0x1c93f9(0x25c),_0x2050b2),console[_0x1c93f9(0x1b1)](_0x1c93f9(0x20b),{'message':_0x2050b2[_0x1c93f9(0x250)],'stack':_0x2050b2[_0x1c93f9(0x236)],'cardData':_0xb762fd,'apiKey':this[_0x1c93f9(0x26c)]?_0x1c93f9(0x2b1):_0x1c93f9(0x293)}),this[_0x1c93f9(0x219)](_0x468342);}finally{this[_0x1c93f9(0x2dc)][_0x1c93f9(0x22e)](_0x468342);}}async['trySearch'](_0x57b160,_0x36ef00=!![]){const _0xd53bb0=a0_0x586fdb;let _0x3555d7;if(_0x36ef00)_0x3555d7=this[_0xd53bb0(0x228)](_0x57b160);else{const _0x2ebd9d=this[_0xd53bb0(0x2e7)](_0x57b160[_0xd53bb0(0x298)]);_0x3555d7=_0xd53bb0(0x223)+_0x2ebd9d+'\x22';}console['log'](_0xd53bb0(0x18b)+(_0x36ef00?_0xd53bb0(0x25a):_0xd53bb0(0x2e1))+':',_0x3555d7);try{const _0x5b39d0=await this[_0xd53bb0(0x2d0)](_0x3555d7);return console[_0xd53bb0(0x2de)](_0xd53bb0(0x270)+(_0x36ef00?_0xd53bb0(0x25a):_0xd53bb0(0x2e1))+'):',_0x5b39d0),_0x5b39d0;}catch(_0x2993f5){return console[_0xd53bb0(0x1b1)](_0xd53bb0(0x174)+(_0x36ef00?_0xd53bb0(0x25a):_0xd53bb0(0x2e1))+':',_0x2993f5),null;}}[a0_0x586fdb(0x228)](_0xc65fe4){const _0x1e82fd=a0_0x586fdb,_0x402f19=this[_0x1e82fd(0x2e7)](_0xc65fe4[_0x1e82fd(0x298)]);console[_0x1e82fd(0x2de)](_0x1e82fd(0x2c1),_0x402f19);let _0x3673aa='name:\x22'+_0x402f19+'\x22';if(_0xc65fe4[_0x1e82fd(0x1ea)]&&_0xc65fe4[_0x1e82fd(0x1ea)][_0x1e82fd(0x229)]()!==''){const _0x52da2e=this[_0x1e82fd(0x206)](_0xc65fe4[_0x1e82fd(0x1ea)]);_0x52da2e&&(_0x3673aa+=_0x1e82fd(0x18d)+_0x52da2e+'\x22');}if(_0xc65fe4['rareza']&&_0xc65fe4[_0x1e82fd(0x1b4)]['trim']()!==''){const _0x1b794b=this[_0x1e82fd(0x1c9)](_0xc65fe4[_0x1e82fd(0x1b4)]);_0x1b794b&&(_0x3673aa+=_0x1e82fd(0x26e)+_0x1b794b+'\x22');}return _0xc65fe4[_0x1e82fd(0x2bb)]&&_0xc65fe4['energia'][_0x1e82fd(0x229)]()!==''&&(_0x3673aa+='\x20types:\x22'+_0xc65fe4['energia']+'\x22'),console[_0x1e82fd(0x2de)](_0x1e82fd(0x232),_0x3673aa),_0x3673aa;}['extractPokemonName'](_0x7b4f3a){return _0x7b4f3a['replace'](/\s+\d+\/\d+.*$/,'')['trim']();}[a0_0x586fdb(0x206)](_0xeee0e6){const _0x3cd534=a0_0x586fdb,_0x178a01={'Scarlet\x20&\x20Violet—Twilight\x20Masquerade':_0x3cd534(0x1d2),'Scarlet\x20&\x20Violet—Temporal\x20Forces':_0x3cd534(0x2d5),'Scarlet\x20&\x20Violet—Paldean\x20Fates':'Paldean\x20Fates','Scarlet\x20&\x20Violet—Paradox\x20Rift':_0x3cd534(0x212),'Scarlet\x20&\x20Violet—151':_0x3cd534(0x27e),'Scarlet\x20&\x20Violet—Obsidian\x20Flames':'Obsidian\x20Flames','Scarlet\x20&\x20Violet—Paldea\x20Evolved':_0x3cd534(0x1b0),'Scarlet\x20&\x20Violet':_0x3cd534(0x199)};return _0x178a01[_0xeee0e6]||_0xeee0e6;}['simplifyRarity'](_0x36e64c){const _0xd74ddf=a0_0x586fdb,_0x260de8={'Illustration\x20Rare':_0xd74ddf(0x28d),'Special\x20Illustration\x20Rare':'Special\x20Illustration\x20Rare','Hyper\x20Rare':_0xd74ddf(0x2b2),'Secret\x20Rare':_0xd74ddf(0x1f0),'Ultra\x20Rare':_0xd74ddf(0x1e0),'Double\x20Rare':'Double\x20Rare','Shiny\x20Rare':'Shiny\x20Rare','Holofoil\x20Rare':'Rare\x20Holo','Rare':_0xd74ddf(0x24e),'Uncommon':_0xd74ddf(0x292),'Common':_0xd74ddf(0x24d)};return _0x260de8[_0x36e64c]||_0x36e64c;}async[a0_0x586fdb(0x2d0)](_0x57df60){const _0x569dc8=a0_0x586fdb,_0x5138d9=this[_0x569dc8(0x180)]+'/cards?q='+encodeURIComponent(_0x57df60)+_0x569dc8(0x277),_0x5407e7={'X-Api-Key':this[_0x569dc8(0x26c)],'Content-Type':_0x569dc8(0x268)};console[_0x569dc8(0x2de)](_0x569dc8(0x1cc),_0x5138d9),console[_0x569dc8(0x2de)](_0x569dc8(0x1e4),this[_0x569dc8(0x26c)]?'Sí':'No');const _0x522273=await fetch(_0x5138d9,{'headers':_0x5407e7});console[_0x569dc8(0x2de)](_0x569dc8(0x265),_0x522273[_0x569dc8(0x1b7)],_0x522273[_0x569dc8(0x286)]);if(!_0x522273['ok']){const _0x3b0bcf=await _0x522273[_0x569dc8(0x203)]();console[_0x569dc8(0x1b1)]('❌\x20Error\x20de\x20API:',_0x3b0bcf);throw new Error('API\x20request\x20failed:\x20'+_0x522273[_0x569dc8(0x1b7)]+_0x569dc8(0x17f)+_0x3b0bcf);}const _0x18c94a=await _0x522273[_0x569dc8(0x1f3)]();return console[_0x569dc8(0x2de)](_0x569dc8(0x1d5),_0x18c94a),_0x18c94a;}[a0_0x586fdb(0x1c8)](_0x287e91,_0x4b2588){const _0x152c09=a0_0x586fdb;let _0x1ea91c=_0x287e91[_0x152c09(0x2a7)](_0x5aa75a=>_0x5aa75a['name'][_0x152c09(0x200)]()===_0x4b2588[_0x152c09(0x298)][_0x152c09(0x200)]());if(_0x1ea91c)return _0x1ea91c;_0x1ea91c=_0x287e91[_0x152c09(0x2a7)](_0x41949a=>_0x41949a[_0x152c09(0x1f2)][_0x152c09(0x200)]()[_0x152c09(0x17a)](_0x4b2588[_0x152c09(0x298)]['toLowerCase']())||_0x4b2588['title'][_0x152c09(0x200)]()[_0x152c09(0x17a)](_0x41949a[_0x152c09(0x1f2)][_0x152c09(0x200)]()));if(_0x1ea91c)return _0x1ea91c;return _0x287e91[0x0];}[a0_0x586fdb(0x175)](_0x1c4c78){const _0x2c282c=a0_0x586fdb,_0x34b006=_0x1c4c78[_0x2c282c(0x23b)](_0x2c282c(0x197)),_0x53c886=_0x34b006[_0x2c282c(0x2e6)](_0x2c282c(0x215)),_0x4ec1b2=_0x34b006[_0x2c282c(0x2e6)]('.pokemon-card-error');if(_0x53c886)_0x53c886['style'][_0x2c282c(0x17d)]=_0x2c282c(0x2b4);if(_0x4ec1b2)_0x4ec1b2[_0x2c282c(0x1cb)][_0x2c282c(0x17d)]='none';_0x1c4c78[_0x2c282c(0x1cb)][_0x2c282c(0x18a)]=_0x2c282c(0x252);}['showError'](_0x4c89fc){const _0x3de009=a0_0x586fdb,_0x53cb72=_0x4c89fc[_0x3de009(0x23b)]('.product-image-container'),_0x34c517=_0x53cb72[_0x3de009(0x2e6)]('.pokemon-card-loading'),_0x3d34ea=_0x53cb72[_0x3de009(0x2e6)](_0x3de009(0x2a0));if(_0x34c517)_0x34c517[_0x3de009(0x1cb)][_0x3de009(0x17d)]='none';if(_0x3d34ea)_0x3d34ea['style'][_0x3de009(0x17d)]=_0x3de009(0x2b4);_0x4c89fc[_0x3de009(0x1cb)][_0x3de009(0x18a)]='1';}[a0_0x586fdb(0x29e)](_0x856c9d,_0x47b819){const _0x195af8=a0_0x586fdb,_0x43feec=_0x856c9d['closest'](_0x195af8(0x197)),_0x273875=_0x43feec[_0x195af8(0x2e6)](_0x195af8(0x215)),_0x1c61fb=_0x43feec[_0x195af8(0x2e6)](_0x195af8(0x2a0));if(_0x273875)_0x273875[_0x195af8(0x1cb)][_0x195af8(0x17d)]=_0x195af8(0x258);if(_0x1c61fb)_0x1c61fb[_0x195af8(0x1cb)][_0x195af8(0x17d)]=_0x195af8(0x258);_0x856c9d['src']=_0x47b819,_0x856c9d['style'][_0x195af8(0x18a)]='1',_0x856c9d[_0x195af8(0x1cb)][_0x195af8(0x1af)]=_0x195af8(0x267);}}function a0_0x3226(){const _0x469a3b=['active','opacity','📝\x20Query\x20','Darkness','\x20set.name:\x22','93324PlIcku','productId','classList','data-product-title','search-suggestions','pokemon_search_state','Grass','updatePagination','data-set','.product-image-container','data','Scarlet\x20&\x20Violet','Error\x20loading\x20Pokemon\x20card\x20image:','location','Tipo:\x20','restorePokemonFilterState','.sort-select','Blastoise','pokemonImageManager','firstChild','target','dataset','createElement','view','cartManager','.sidebar-overlay','pokemon_language','init','DOMContentLoaded','initializeButtons','pokemon-search-input','Error\x20adding\x20pre-order','\x0a\x20\x20\x20\x20\x20\x20<svg\x20width=\x2218\x22\x20height=\x2218\x22\x20viewBox=\x220\x200\x2018\x2018\x22\x20fill=\x22none\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20<path\x20d=\x22M3\x205h12M3\x209h12M3\x2013h12\x22\x20stroke=\x22currentColor\x22\x20stroke-width=\x222\x22\x20stroke-linecap=\x22round\x22/>\x0a\x20\x20\x20\x20\x20\x20</svg>\x0a\x20\x20\x20\x20\x20\x20Filtros\x0a\x20\x20\x20\x20','transition','Paldea\x20Evolved','error','cache','.product-card','rareza','populateExpansionFilter','generateCacheKey','status','Artículo\x20de\x20pre-venta','sort_by','pokemon_search','✅\x20Encontradas\x20cartas:','Team\x20Rocket','setupFilterGroups','EX\x20Ruby\x20&\x20Sapphire','getItem','setItem','trySearch','next-page','Producto\x20','filterGroups','pokemon_type','innerHTML','7860Nrrqke','findBestMatch','simplifyRarity','PokemonTCGCacheInstance','style','🌐\x20URL\x20de\x20API:','setupFilterInputs','addEventListener','textContent','from','parse','Twilight\x20Masquerade','filter','get','📦\x20Datos\x20recibidos:','Coreano','searchParams','❌\x20No\x20se\x20encontró\x20imagen\x20en\x20el\x20tamaño\x20especificado:','URL\x20base:','localId','🖼️\x20URL\x20de\x20imagen:','📊\x20Imágenes\x20disponibles:','option','originalText','Dragon','Ultra\x20Rare','🔄\x20Primera\x20búsqueda\x20falló,\x20intentando\x20búsqueda\x20simple...','loadPokemonCardImages','.search-suggestion-item','🔑\x20API\x20Key\x20configurada:','observe','match','handlePreorder','warn','.filter-form','set','3369210vztfTl','959712rwnMdF','handleAddToCart','push','pokemon-card-image','Secret\x20Rare','toString','name','json','search-cardtype-filter','getElementById','replace','showPage','startsWith','length','productTitle','Japonés','🔍\x20Buscando\x20carta\x20Pokemon:','\x0a\x20\x20\x20\x20\x20\x20<h3\x20class=\x22sidebar-title\x22>Filtros</h3>\x0a\x20\x20\x20\x20\x20\x20<button\x20class=\x22sidebar-close\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20<svg\x20width=\x2224\x22\x20height=\x2224\x22\x20viewBox=\x220\x200\x2024\x2024\x22\x20fill=\x22none\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<path\x20d=\x22M18\x206L6\x2018M6\x206l12\x2012\x22\x20stroke=\x22currentColor\x22\x20stroke-width=\x222\x22\x20stroke-linecap=\x22round\x22/>\x0a\x20\x20\x20\x20\x20\x20\x20\x20</svg>\x0a\x20\x20\x20\x20\x20\x20</button>\x0a\x20\x20\x20\x20','map','input','toLowerCase','setupPagination','❌\x20No\x20se\x20encontraron\x20cartas','text','loadPokemonCardImage','body','simplifySetName','forEach','Español','No\x20disponible','Black\x20&\x20White','🔧\x20Detalles\x20del\x20error:','div','add','Neo\x20Genesis','Base\x20Set','Agregado\x20al\x20carrito','filterInputs','Paradox\x20Rift','updatePaginationDisplay','action','.pokemon-card-loading','pokemonLoaded','⚠️\x20No\x20se\x20configuró\x20la\x20API\x20key\x20de\x20Pokemon\x20TCG','fetchTCGdexCard','showError','ceil','https://api.pokemontcg.io/v2/cards?q=name:\x22','href','POKEMON_DEBUG','Pikachu','https://api.pokemontcg.io/v2','filter.','toggleSidebar','handleFilterChange','name:\x22','Fossil','.collection-sidebar','🔧\x20Debug\x20de\x20configuración\x20Pokemon\x20TCG:','.filter-group-content','buildSearchQuery','trim','loading','Página\x20','setupPokemonSearch','pokemon_expansion','delete','Error\x20adding\x20to\x20cart','totalVisibleItems','enabled','🔍\x20Query\x20final:','perPageSelect','nextPage','Dragonite','stack','querySelectorAll','handleSearchInput','.price-range-inputs\x20input','Error\x20restoring\x20search\x20state:','closest','contains','expansion','🔍\x20Mostrando\x20página:','Gyarados','/cart/add.js','<option\x20value=\x22\x22>Todas\x20las\x20expansiones</option>','POKEMON_IMAGE_SIZE','data-rareza','getAttribute','data-api-enabled','🔑\x20API\x20Key\x20disponible:','🔍\x20Productos\x20mostrados\x20en\x20esta\x20página:','flex','innerWidth','autoPreloadVisibleCards','keys','query','Common','Rare','loadCardFromAPI','message','extractCardData','0.3','small','true','Water','maxRetries','Sun\x20&\x20Moon','none','Fighting','completa','\x22&pageSize=10','💥\x20Error\x20cargando\x20imagen\x20de\x20carta\x20Pokemon:','setupPerPage','Rare\x20Holo','code','Expansión:\x20','click','rarity','handleClick','Error\x20updating\x20cart:','📡\x20Status\x20de\x20respuesta:','pokemonApiKey','opacity\x200.3s\x20ease','application/json','restoreSearchState','data-tipo','🔍\x20Productos\x20mostrados\x20(sin\x20paginación):','apiKey','No\x20configurado','\x20rarity:\x22','tipo','📡\x20Respuesta\x20de\x20API\x20(','imageSize','removeItem','appendChild','5363388jxQAZJ','submit','2744436nLSTss','&pageSize=50','.filter-group','filterManager','🎯\x20Carta\x20seleccionada:','clearPokemonCache','Rareza:\x20','pokemon-search-btn','151','has','❌\x20API\x20Key\x20no\x20configurada','355NaXlrD','productHandle','currentPage','reload','Charizard','statusText','Mewtwo','search-rarity-filter','🔍\x20Productos\x20inicializados\x20como\x20visibles:','showAllVisibleProducts','change','🔍\x20Total\x20de\x20productos\x20encontrados:','Illustration\x20Rare','Fire','initializeImageLoading','cardtype','preventDefault','Uncommon','No\x20configurada','type','entries','API\x20Key:','showSuccess','title','search-type-filter','search-expansion-filter','pokemon_cardtype','Pokemon\x20TCG\x20Cache:\x20Sistema\x20no\x20disponible','clear-search-btn','updateImage','className','.pokemon-card-error','button','pokemonCardId','prev-page','catch','generateSuggestions','🔍\x20Expansiones\x20encontradas\x20en\x20el\x20grid:','find','pokemon_card_','sort','pagination-info','N/A','📡\x20Resultados\x20de\x20búsqueda:','Inglés','💡\x20Para\x20configurar:\x20Admin\x20>\x20Temas\x20>\x20Customize\x20>\x20Collection\x20Product\x20Grid\x20>\x20Pokemon\x20TCG\x20API\x20Key','pagination','then','Configurada','Hyper\x20Rare','false','block','Fairy','🔍\x20Mostrando\x20todos\x20los\x20productos\x20visibles\x20(sin\x20paginación)','Italiano','setupSort','slice','insertBefore','energia','form','productCards','append','POST','.pokemon-card-image','🎯\x20Nombre\x20extraído:','value','📏\x20Tamaño\x20de\x20imagen:','sortSelect','Error','1831782ePdQJR','min','sidebar-overlay','🔍\x20Actualizando\x20paginación:','dispatchEvent','Tamaño\x20de\x20imagen:','105NxoJCh','.sidebar-close','search-language-filter','Lightning','searchPokemonCard','itemsPerPage','.apply-price-filter','.filter-toggle','Jungle','Temporal\x20Forces','disabled','Procesando...','\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20','Carta\x20','pokemon_rarity','https://api.tcgdex.net/v2/en/cards/','loadingCards','stringify','log','join','setLoading','simple','updateCart','Venusaur','category','💥\x20Error\x20en\x20búsqueda\x20manual:','querySelector','extractPokemonName','idioma','cart:updated','populateLanguageFilter','medium','❌\x20Error\x20en\x20búsqueda\x20','showLoading','filtered','Colorless','POKEMON_API_KEY','\x22\x20data-category=\x22','includes','📊\x20Productos\x20encontrados:','\x20de\x20','display','cdn','\x20-\x20','baseUrl','.filter-group-header','clearSearch','language','Diamond\x20&\x20Pearl','images','remove','testPokemonSearch','\x0a\x20\x20\x20\x20\x20\x20</div>'];a0_0x3226=function(){return _0x469a3b;};return a0_0x3226();}window[a0_0x586fdb(0x27b)]=function(){const _0x4577c8=a0_0x586fdb;localStorage[_0x4577c8(0x272)]('pokemon_tcg_collection_cache');const _0x4828d6=Object[_0x4577c8(0x24b)](localStorage);_0x4828d6['forEach'](_0x4f052a=>{const _0x1cae3f=_0x4577c8;_0x4f052a[_0x1cae3f(0x1f8)](_0x1cae3f(0x2a8))&&localStorage[_0x1cae3f(0x272)](_0x4f052a);}),debugLog('Pokemon\x20TCG\x20cache\x20cleared'),location[_0x4577c8(0x284)]();},window['debugPokemonConfig']=function(){const _0x21fcd4=a0_0x586fdb;debugLog(_0x21fcd4(0x226)),debugLog(_0x21fcd4(0x296),window[_0x21fcd4(0x178)]?_0x21fcd4(0x2b1):_0x21fcd4(0x293)),debugLog(_0x21fcd4(0x2cb),window[_0x21fcd4(0x242)]||_0x21fcd4(0x26d)),debugLog(_0x21fcd4(0x1d9),_0x21fcd4(0x21f));const _0x4a78a8=document[_0x21fcd4(0x237)](_0x21fcd4(0x2c0));debugLog(_0x21fcd4(0x17b),_0x4a78a8[_0x21fcd4(0x1f9)]),_0x4a78a8[_0x21fcd4(0x207)]((_0x2fbe,_0x2efe21)=>{const _0x5dbb54=_0x21fcd4;debugLog(_0x5dbb54(0x1c3)+(_0x2efe21+0x1)+':',{'title':_0x2fbe[_0x5dbb54(0x1a3)][_0x5dbb54(0x1fa)],'rareza':_0x2fbe[_0x5dbb54(0x1a3)]['rareza'],'energia':_0x2fbe[_0x5dbb54(0x1a3)]['energia'],'set':_0x2fbe[_0x5dbb54(0x1a3)][_0x5dbb54(0x1ea)],'idioma':_0x2fbe[_0x5dbb54(0x1a3)]['idioma'],'tipo':_0x2fbe['dataset'][_0x5dbb54(0x26f)]});});},window[a0_0x586fdb(0x187)]=function(_0x2386ff){const _0x48ff9f=a0_0x586fdb;if(!window[_0x48ff9f(0x178)]){debugError(_0x48ff9f(0x280));return;}debugLog('🧪\x20Probando\x20búsqueda\x20manual\x20para:',_0x2386ff);const _0x1d5a0b=_0x48ff9f(0x21b)+_0x2386ff+_0x48ff9f(0x25b),_0xe47b40={'X-Api-Key':window['POKEMON_API_KEY'],'Content-Type':_0x48ff9f(0x268)};fetch(_0x1d5a0b,{'headers':_0xe47b40})[_0x48ff9f(0x2b0)](_0x3a3474=>_0x3a3474['json']())[_0x48ff9f(0x2b0)](_0x493b69=>{const _0x372c97=_0x48ff9f;debugLog(_0x372c97(0x2ac),_0x493b69),_0x493b69[_0x372c97(0x198)]&&_0x493b69[_0x372c97(0x198)]['length']>0x0?(debugLog(_0x372c97(0x1bb),_0x493b69['data']['length']),_0x493b69[_0x372c97(0x198)][_0x372c97(0x207)]((_0x32543f,_0x3e05b1)=>{const _0x4d78d2=_0x372c97;debugLog(_0x4d78d2(0x2d9)+(_0x3e05b1+0x1)+':',{'name':_0x32543f[_0x4d78d2(0x1f2)],'set':_0x32543f[_0x4d78d2(0x1ea)]?.[_0x4d78d2(0x1f2)],'rarity':_0x32543f[_0x4d78d2(0x262)],'images':_0x32543f[_0x4d78d2(0x185)]?Object['keys'](_0x32543f[_0x4d78d2(0x185)]):_0x4d78d2(0x209)});})):debugLog(_0x372c97(0x202));})[_0x48ff9f(0x2a4)](_0x36d655=>{const _0x3145ca=_0x48ff9f;debugError(_0x3145ca(0x2e5),_0x36d655);});},document[a0_0x586fdb(0x1ce)](a0_0x586fdb(0x1aa),()=>{const _0x1ce3ef=a0_0x586fdb;new CollectionManager(),debugLog('🚀\x20Inicializando\x20Pokemon\x20TCG\x20Image\x20Loader...'),debugLog(_0x1ce3ef(0x246),window[_0x1ce3ef(0x178)]?'Sí':'No'),debugLog(_0x1ce3ef(0x2c3),window[_0x1ce3ef(0x242)]||_0x1ce3ef(0x26d)),window['POKEMON_API_KEY']&&window[_0x1ce3ef(0x178)]['trim']()!==''?(debugLog('✅\x20Iniciando\x20PokemonCardImageLoader'),new PokemonCardImageLoader(),setTimeout(()=>{const _0x3df0d6=_0x1ce3ef;window[_0x3df0d6(0x24a)]&&(debugLog('🔄\x20Iniciando\x20precarga\x20automática\x20de\x20cartas\x20visibles...'),window[_0x3df0d6(0x24a)]());},0xbb8)):(debugWarn(_0x1ce3ef(0x217)),debugLog(_0x1ce3ef(0x2ae)));});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !window.DesignMode) return;
  try {
    
class CollectionManager {
  constructor() {
    this.filterManager = new FilterManager();
    this.cartManager = new CartManager();
    this.initializeButtons();
  }

  initializeButtons() {
    document.querySelectorAll('.product-button').forEach(button => {
      new ProductButton(button);
    });
  }
}

class FilterManager {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.filterGroups = document.querySelectorAll('.filter-group');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortSelect = document.querySelector('.sort-select');
    this.perPageSelect = document.querySelector('.per-page-select');
    
    this.init();
  }

  init() {
    this.setupFilterGroups();
    this.setupFilterInputs();
    this.setupSort();
    this.setupPerPage();
    this.initMobileSidebar();
  }

  initMobileSidebar() {
    // Crear botón de toggle para móvil
    const toggleButton = document.createElement('button');
    toggleButton.className = 'filter-toggle-button';
    toggleButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      Filtros
    `;
    document.body.appendChild(toggleButton);

    // Crear overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    document.body.appendChild(overlay);

    // Crear header del sidebar
    const sidebarHeader = document.createElement('div');
    sidebarHeader.className = 'sidebar-header';
    sidebarHeader.innerHTML = `
      <h3 class="sidebar-title">Filtros</h3>
      <button class="sidebar-close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    
    // Insertar header al inicio del sidebar
    const sidebar = document.querySelector('.collection-sidebar');
    sidebar.insertBefore(sidebarHeader, sidebar.firstChild);

    // Event listeners
    toggleButton.addEventListener('click', () => this.toggleSidebar(true));
    overlay.addEventListener('click', () => this.toggleSidebar(false));
    sidebarHeader.querySelector('.sidebar-close').addEventListener('click', () => this.toggleSidebar(false));

    // Cerrar al cambiar filtros en mobile
    if (window.innerWidth <= 991) {
      this.filterInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Pequeño delay para que el usuario vea que se seleccionó el filtro
          setTimeout(() => this.toggleSidebar(false), 300);
        });
      });
    }
  }

  toggleSidebar(show) {
    const sidebar = document.querySelector('.collection-sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (show) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('sidebar-open');
    } else {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }
  }

  setupFilterGroups() {
    this.filterGroups.forEach(group => {
      const header = group.querySelector('.filter-group-header');
      const content = group.querySelector('.filter-group-content');
      const toggle = header.querySelector('.filter-toggle');

      // Establecer estado inicial
      content.classList.add('active');
      toggle.textContent = '▲';

      header.addEventListener('click', () => {
        const isExpanded = content.classList.contains('active');
        
        if (isExpanded) {
          content.classList.remove('active');
          toggle.textContent = '▼';
        } else {
          content.classList.add('active');
          toggle.textContent = '▲';
        }
      });
    });
  }

  setupFilterInputs() {
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => this.handleFilterChange());
    });
  }

  setupSort() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        window.location = url.toString();
      });
    }
  }

  setupPerPage() {
    if (this.perPageSelect) {
      this.perPageSelect.addEventListener('change', (e) => {
        const url = new URL(window.location.href);
        url.searchParams.set('view', e.target.value);
        window.location = url.toString();
      });
    }
  }

  handleFilterChange() {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Limpiar filtros existentes
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Añadir filtros activos
    for (let [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }

    // Mantener sort y page_size
    const currentSort = url.searchParams.get('sort_by');
    const currentView = url.searchParams.get('view');

    if (currentSort) url.searchParams.set('sort_by', currentSort);
    if (currentView) url.searchParams.set('view', currentView);

    window.location = url.toString();
  }
}

class ProductButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productHandle = button.dataset.productHandle;
    this.action = button.dataset.action;
    this.originalText = button.textContent;
    
    this.init();
  }

  init() {
    this.button.addEventListener('click', () => this.handleClick());
  }

  async handleClick() {
    if (this.button.disabled) return;

    try {
      this.setLoading(true);
      
      if (this.action === 'preorder') {
        await this.handlePreorder();
      } else {
        await this.handleAddToCart();
      }
      
      this.showSuccess();
      CartManager.updateCart();
      
    } catch (error) {
      console.error('Error:', error); display: none
      this.showError(); display: none
    }
  }

  async handleAddToCart() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding to cart');
  }

  async handlePreorder() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.productId,
          quantity: 1,
          properties: {
            '_preorder': true,
            'Estimated Shipping': 'Pre-order - 2-3 semanas',
            'Pre-order': 'Artículo de pre-venta'
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Error adding pre-order');
  }

  setLoading(isLoading) {
    this.button.enabled = isLoading; 
    this.button.classList.toggle('loading', isLoading);display: none
    this.button.textContent = isLoading ? 'Procesando...' : this.originalText; display: none
  }

  showSuccess() {
    const message = this.action === 'preorder' ? 'Pre-orden agregada' : 'Agregado al carrito';
    this.button.textContent = message;
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }

  showError() {
    this.button.textContent = 'Error'; display: none
    
    setTimeout(() => {
      this.button.disabled = false;
      this.button.textContent = this.originalText;
    }, 2000);
  }
}

class CartManager {
  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error updating cart:', error); display: none
    }
  }
}

// Agregar al JavaScript existente
document.addEventListener('DOMContentLoaded', function() {
  const priceForm = document.querySelector('.filter-form');
  const priceInputs = document.querySelectorAll('.price-range-inputs input');
  
  priceInputs.forEach(input => {
    input.addEventListener('input', function() {
      if (this.value < 0) this.value = 0;
    });
  });

  document.querySelector('.apply-price-filter')?.addEventListener('click', function(e) {
    e.preventDefault();
    priceForm.submit();
  });
});  

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new CollectionManager();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
    
// Animate elements when they enter viewport
if (document.querySelector('.blog-card')) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, {
    threshold: 0.1
  });

  document.querySelectorAll('.blog-card').forEach((card) => {
    observer.observe(card);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Featured-News-Banner"] && !window.DesignMode) return;
  try {
    
class FeaturedNewsBanner {
  constructor(section) {
    this.container = section;
    this.slides = this.container.querySelectorAll('.featured-news__slide');
    this.dots = this.container.querySelectorAll('.featured-news__dot');
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.transitionInProgress = false;

    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.goToSlide(index);
      });
    });

    // Pause autoplay on hover/touch
    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => this.startAutoplay());
    this.container.addEventListener('touchstart', () => this.stopAutoplay());
    this.container.addEventListener('touchend', () => this.startAutoplay());

    // Handle visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  goToSlide(index) {
    if (this.transitionInProgress || index === this.currentIndex) return;

    this.transitionInProgress = true;
    
    // Remove active classes
    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex].setAttribute('aria-selected', 'false');

    // Add active classes
    this.slides[index].classList.add('is-active');
    this.dots[index].classList.add('is-active');
    this.dots[index].setAttribute('aria-selected', 'true');

    // Update current index
    this.currentIndex = index;

    // Reset transition lock
    setTimeout(() => {
      this.transitionInProgress = false;
    }, 600);
  }

  startAutoplay() {
    if (this.slides.length <= 1) return;

    this.autoplayInterval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }, 5000);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

// Initialize the section
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.featured-news');
  if (section) {
    new FeaturedNewsBanner(section);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Código existente de la carta holográfica
  const root = document.documentElement;
  const holoCard = document.querySelector('.hero-holo-card .card');
  const featuredCardImage = document.querySelector('.featured-card-image');
  const slides = document.querySelectorAll('.hero-banner__slide');

  // Nuevas variables para el carousel
  const banner = document.querySelector('[data-banner]');
  const dots = document.querySelectorAll('.hero-banner__dot');
  const autoplaySpeed = parseInt(banner?.dataset.autoplaySpeed) * 1000 || 5000;
  let currentSlide = 0;
  let autoplayInterval;
  
  if (!holoCard || !featuredCardImage) return;

  let isHovering = false;
  let animationFrame;
  
  // Configuración
  const config = {
    // Animación automática
    autoAnimation: {
      start: Date.now(),
      duration: 6000, // 6 segundos por ciclo
      rotationIntensity: {
        auto: { x: 1, y: 2 },    // Intensidad de rotación automática
        hover: { x: 5, y: 5 }     // Intensidad de rotación con hover
      }
    },
    // Efectos holográficos
    holo: {
      baseOpacity: 0.5,          // Opacidad base del efecto
      opacityIntensity: 0.3,     // Intensidad máxima adicional
      blurRadius: '3rem',        // Radio del efecto blur
      gradientSize: '150px'      // Tamaño del gradiente
    },
    // Transiciones
    transition: {
      duration: 300,            // Duración de la transición en ms
      timing: 'ease-out'        // Timing function
    }
  };

  // Funciones del carousel
  function showSlide(index) {
    slides.forEach(slide => slide.classList.remove('is-active'));
    dots.forEach(dot => dot.classList.remove('is-active'));
    
    slides[index].classList.add('is-active');
    dots[index].classList.add('is-active');
    
    updateFeaturedCard();
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }

  function prevSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(currentSlide);
  }

  function startAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Event listeners para navegación
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      showSlide(currentSlide);
      startAutoplay();
    });
  });

  banner.addEventListener('mouseenter', stopAutoplay);
  banner.addEventListener('mouseleave', startAutoplay);

  // Modificar el manejo de visibilidad de página
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrame);
      stopAutoplay();
    } else if (!isHovering) {
      autoAnimate();
      startAutoplay();
    }
  });

  // Función para actualizar la carta según el slide activo
 function updateFeaturedCard() {
  const activeSlide = document.querySelector('.hero-banner__slide.is-active');
  if (!activeSlide) return;

  const cardImageUrl = activeSlide.dataset.featuredCard;
  if (!cardImageUrl) return;

  const cardContainer = document.querySelector('.hero-holo-card');
  const cardWrapper = document.querySelector('.card-wrapper');
  const frontImage = document.querySelector('.featured-card-image');
  const backImage = document.querySelector('.featured-card-image-back');

  // Añadir clase para ocultar efectos durante la transición
  cardContainer.classList.add('is-flipping');

  // Determinar si la carta está en su posición frontal o posterior
  const isFlipped = cardWrapper.style.transform.includes('180deg');
  
  // Establecer la nueva imagen en el lado opuesto
  if (isFlipped) {
    frontImage.src = cardImageUrl;
  } else {
    backImage.src = cardImageUrl;
  }

  // Realizar el flip
  cardWrapper.style.transform = isFlipped ? 'rotateY(0deg)' : 'rotateY(180deg)';

  // Restaurar efectos después de la transición
  cardWrapper.addEventListener('transitionend', function handler() {
    // Pequeño retraso antes de remover la clase is-flipping
    setTimeout(() => {
      cardContainer.classList.remove('is-flipping');
    }, 50);
    
    // Actualizar la imagen del otro lado para mantener sincronización
    if (isFlipped) {
      backImage.src = cardImageUrl;
    } else {
      frontImage.src = cardImageUrl;
    }
    
    cardWrapper.removeEventListener('transitionend', handler);
  }, { once: true });
}

  // Observer para detectar cambios en los slides
  const slideObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('is-active')) {
        updateFeaturedCard();
      }
    });
  });

  // Observar cambios en cada slide
  slides.forEach(slide => {
    slideObserver.observe(slide, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // Establecer variables CSS iniciales
  root.style.setProperty('--active-blur', config.holo.baseOpacity.toString());
  root.style.setProperty('--gradient-size', config.holo.gradientSize);
  
  // Función para la animación automática
  function autoAnimate() {
    if (isHovering) return;
    
    const now = Date.now();
    const elapsed = now - config.autoAnimation.start;
    const progress = (elapsed % config.autoAnimation.duration) / config.autoAnimation.duration;
    
    // Movimiento circular suave
    const angle = progress * Math.PI * 2;
    const rotateY = Math.sin(angle) * config.autoAnimation.rotationIntensity.auto.y;
    const rotateX = Math.cos(angle) * config.autoAnimation.rotationIntensity.auto.x;
    
    // Aplicar transformación
    holoCard.style.transform = `
      perspective(2000px)
      rotateY(${rotateY}deg) 
      rotateX(${rotateX}deg)
    `;
    
    // Efecto de brillo automático
    const x = (Math.sin(angle) * 0.5 + 0.5) * 100;
    const y = (Math.cos(angle) * 0.5 + 0.5) * 100;
    updateHoloEffect(x, y);
    
    animationFrame = requestAnimationFrame(autoAnimate);
  }

  // Función para actualizar el efecto holográfico
  function updateHoloEffect(x, y) {
    const intensity = (Math.sin(Date.now() / 1000) * 0.5 + 0.5) * config.holo.opacityIntensity;
    const opacity = config.holo.baseOpacity + intensity;
    
    root.style.setProperty('--mouse-x', `${x}%`);
    root.style.setProperty('--mouse-y', `${y}%`);
    root.style.setProperty('--active-blur', opacity.toString());
    root.style.setProperty('--active-scale', '1');
  }

  // Eventos del mouse
  holoCard.addEventListener('mouseenter', () => {
    isHovering = true;
    cancelAnimationFrame(animationFrame);
    holoCard.style.transition = `transform ${config.transition.duration}ms ${config.transition.timing}`;
  });

  holoCard.addEventListener('mousemove', (e) => {
    if (!isHovering) return;

    const rect = holoCard.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const percentX = (mouseX - centerX) / centerX;
    const percentY = (mouseY - centerY) / centerY;

    const rotateY = percentX * config.autoAnimation.rotationIntensity.hover.y;
    const rotateX = -percentY * config.autoAnimation.rotationIntensity.hover.x;

    holoCard.style.transform = `
      perspective(2000px)
      rotateY(${rotateY}deg)
      rotateX(${rotateX}deg)
      scale3d(1.02, 1.02, 1.02)
    `;

    updateHoloEffect(
      (mouseX / rect.width) * 100,
      (mouseY / rect.height) * 100
    );
  });

  holoCard.addEventListener('mouseleave', () => {
    isHovering = false;
    holoCard.style.transition = `transform ${config.transition.duration * 2}ms ${config.transition.timing}`;
    holoCard.style.transform = 'rotateY(0) rotateX(0)';
    
    config.autoAnimation.start = Date.now();
    autoAnimate();
  });

  // Optimización del rendimiento
  window.addEventListener('resize', _.debounce(() => {
    if (holoCard) {
      holoCard.style.transform = 'rotateY(0) rotateX(0)';
    }
  }, 250));

  // Inicialización
  updateFeaturedCard(); // Establecer carta inicial
  autoAnimate();       // Iniciar animación automática
  startAutoplay();

  // Manejo de visibilidad de página
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrame);
    } else if (!isHovering) {
      autoAnimate();
    }
  });

  // Limpieza
  window.addEventListener('unload', () => {
    slideObserver.disconnect();
    cancelAnimationFrame(animationFrame);
    stopAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductPage {
  constructor() {
    if (!this.checkElements()) return;
    this.initializeElements();
    this.initializeState();
    if (this.state.isPreorder && !this.validatePreorderSetup()) {
      console.error('Configuración de preventa inválida');
      return;
    }
    this.bindEvents();
  }

  checkElements() {
    const required = [
      '.quantity-input',
      '.product-button',
      '.tab-button',
      '.tab-panel',
      '#ProductMainImage'
    ];

    return required.every(selector => document.querySelector(selector));
  }

  initializeElements() {
    // Elementos de cantidad
    this.quantityInput = document.querySelector('.quantity-input');
    this.quantityBtns = document.querySelectorAll('.quantity-btn');
    
    // Elementos de tabs
    this.tabButtons = document.querySelectorAll('.tab-button');
    
    // Elementos de galería
    this.mainImage = document.querySelector('#ProductMainImage');
    this.thumbnails = document.querySelectorAll('.thumbnail-item');
    
    // Botones de preventa/carrito
    this.cartButtons = document.querySelectorAll('.product-button');
    
    // Elementos de precios
    this.priceElements = {
      total: document.querySelector('.price-total'),
      reserve: document.querySelector('.price-reserve'),
      remaining: document.querySelector('.remaining-balance .price-value')
    };
  }

  initializeState() {
    const preorderButton = document.querySelector('.product-button.initial-payment');
    const fullPaymentButton = document.querySelector('.product-button.full-payment');
    
    this.state = {
      quantity: 1,
      selectedVariantId: this.getSelectedVariantId(),
      isPreorder: this.checkIfPreorder(),
      prices: null,
      preorderVariantId: preorderButton?.dataset.preorderVariantId || null
    };

    // Verificar datos necesarios para preventa
    if (this.state.isPreorder) {
      const initialPrice = preorderButton ? parseFloat(preorderButton.dataset.initialPrice) : 0;
      const totalPrice = fullPaymentButton ? parseFloat(fullPaymentButton.dataset.totalPrice) : 0;
      
      if (!initialPrice || !totalPrice || !this.state.preorderVariantId) {
        console.error('Faltan datos necesarios para la preventa:', {
          initialPrice,
          totalPrice,
          preorderVariantId: this.state.preorderVariantId
        });
        this.state.isPreorder = false;
      } else {
        this.state.prices = { initial: initialPrice, total: totalPrice };
      }
    }
  }

  validatePreorderSetup() {
    if (!this.state.isPreorder) return true;

    const validations = [
      {
        condition: !!this.state.preorderVariantId,
        message: 'No se encontró la variante de apartado'
      },
      {
        condition: !!this.state.prices?.initial,
        message: 'Precio de apartado no configurado'
      },
      {
        condition: !!this.state.prices?.total,
        message: 'Precio total no configurado'
      }
    ];

    const failures = validations
      .filter(v => !v.condition)
      .map(v => v.message);

    if (failures.length > 0) {
      console.error('Errores en la configuración de preventa:', failures);
      return false;
    }

    return true;
  }

  getSelectedVariantId() {
    const variantSelect = document.querySelector('#ProductSelect');
    return variantSelect ? variantSelect.value : this.cartButtons[0].dataset.productId;
  }

  checkIfPreorder() {
    return document.querySelector('.preorder-badge') !== null && 
           this.verifyPreorderVariant();
  }

  verifyPreorderVariant() {
    const preorderButton = document.querySelector('.product-button.initial-payment');
    if (!preorderButton) return false;

    const preorderVariantId = preorderButton.dataset.preorderVariantId;
    if (!preorderVariantId) {
      console.error('No se encontró la variante de apartado');
      return false;
    }

    return true;
  }

  bindEvents() {
    // Eventos de cantidad
    this.quantityBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleQuantityChange(btn.dataset.action);
      });
    });

    this.quantityInput.addEventListener('change', () => this.handleQuantityInput());
    
    // Eventos de tabs
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => this.handleTabChange(button));
    });
    
    // Eventos de galería
    this.thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => this.handleThumbnailClick(thumb));
    });
    
    // Eventos de carrito
    this.cartButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleAddToCart(button);
      });
    });

    // Eventos de variantes
    const variantSelect = document.querySelector('#ProductSelect');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => this.handleVariantChange());
    }
  }

  handleQuantityChange(action) {
    let newQuantity = parseInt(this.quantityInput.value);
    
    if (action === 'decrease' && newQuantity > 1) {
      newQuantity--;
    } else if (action === 'increase') {
      newQuantity++;
    }

    this.updateQuantity(newQuantity);
  }

  handleQuantityInput() {
    let value = parseInt(this.quantityInput.value);
    if (isNaN(value) || value < 1) value = 1;
    this.updateQuantity(value);
  }

  updateQuantity(quantity) {
    this.state.quantity = quantity;
    this.quantityInput.value = quantity;
    this.updatePrices();
    this.updateButtonText();
  }

  

  handleThumbnailClick(thumbnail) {
    const newSrc = thumbnail.querySelector('img').dataset.mainSrc;
    
    // Transición suave
    this.mainImage.style.opacity = '0';
    setTimeout(() => {
      this.mainImage.src = newSrc;
      this.mainImage.style.opacity = '1';
    }, 300);
    
    this.thumbnails.forEach(thumb => {
      thumb.classList.toggle('active', thumb === thumbnail);
    });
  }

  handleVariantChange() {
    this.state.selectedVariantId = this.getSelectedVariantId();
    this.updatePrices();
    this.updateButtonStates();
  }

  updatePrices() {
    if (!this.state.isPreorder) return;

    const quantity = this.state.quantity;
    const { total, initial } = this.state.prices;

    if (this.priceElements.total) {
      this.priceElements.total.textContent = this.formatMoney(total * quantity);
    }
    if (this.priceElements.reserve) {
      this.priceElements.reserve.textContent = this.formatMoney(initial * quantity);
    }
    if (this.priceElements.remaining) {
      this.priceElements.remaining.textContent = 
        this.formatMoney((total - initial) * quantity);
    }
  }

  updateButtonText() {
    this.cartButtons.forEach(button => {
      const isPreorderBtn = button.classList.contains('preorder');
      const paymentType = button.dataset.paymentType;
      const quantity = this.state.quantity;
      
      let buttonText = '';
      if (isPreorderBtn) {
        if (paymentType === 'full') {
          const totalPrice = (this.state.prices.total * quantity).toFixed(2);
          buttonText = `Pagar Precio Total ($${totalPrice})`;
        } else {
          const initialPrice = (this.state.prices.initial * quantity).toFixed(2);
          buttonText = `Realizar Apartado ($${initialPrice})`;
        }
      } else {
        buttonText = quantity > 1 ? `Agregar ${quantity} al carrito` : 'Agregar al carrito';
      }
      
      button.textContent = buttonText;
    });
  }

  updateButtonStates() {
    const variant = this.getSelectedVariant();
    const isAvailable = variant && variant.available;

    this.cartButtons.forEach(button => {
      button.disabled = !isAvailable;
      if (!isAvailable) {
        button.textContent = 'Agotado';
      } else {
        this.updateButtonText();
      }
    });
  }

  getSelectedVariant() {
    const select = document.querySelector('#ProductSelect');
    if (!select) return null;
    
    const option = select.options[select.selectedIndex];
    return {
      id: option.value,
      available: !option.disabled
    };
  }

  
async handleAddToCart(button) {
  if (button.disabled || button.classList.contains('loading')) return;
  
  const isPreorder = button.classList.contains('preorder');
  const paymentType = button.dataset.paymentType;
  const quantity = this.state.quantity;

  try {
    this.setButtonLoading(button, true);
    
    // Obtener el producto actual y sus variantes
    if (!window.product) {
      throw new Error('No se encontró información del producto');
    }

    let selectedVariant;
    let cartProperties = {};

    if (isPreorder) {
      // Lógica para productos de preventa
      if (!window.product.variants || window.product.variants.length < 2) {
        throw new Error('El producto de preventa está agotado');
      }

      if (paymentType === 'full') {
        // Pago total: usar primera variante
        selectedVariant = window.product.variants[0];
        cartProperties = {
          '_tipo_pago': 'Pago total preventa',
          '_monto_total': (selectedVariant.price / 100).toFixed(2),
          '_cantidad': quantity,
          '_es_pago_completo': true
        };
      } else {
        // Apartado: usar segunda variante
        selectedVariant = window.product.variants[1];
        const precioTotal = window.product.variants[0].price / 100;
        const precioApartado = selectedVariant.price / 100;
        
        cartProperties = {
          '_tipo_pago': 'Apartado preventa',
          '_monto_apartado': precioApartado.toFixed(2),
          '_precio_total': precioTotal.toFixed(2),
          '_saldo_pendiente': (precioTotal - precioApartado).toFixed(2),
          '_cantidad': quantity,
          '_es_apartado': true
        };
      }
    } else {
      // Lógica para productos normales
      const variantId = button.dataset.productId;
      selectedVariant = {
        id: variantId
      };
    }

    // Verificar que la variante sea válida
    if (!selectedVariant || !selectedVariant.id) {
      throw new Error('No se pudo obtener una variante válida');
    }

    // Preparar datos para el carrito
    const cartData = {
      items: [{
        id: selectedVariant.id,
        quantity: quantity,
        properties: cartProperties
      }]
    };

    console.log('Datos a enviar al carrito:', cartData);

    // Construir URL completa para el carrito
    const cartUrl = window.Shopify && window.Shopify.routes ? 
      window.Shopify.routes.root + 'cart/add.js' : 
      '/cart/add.js';

    // Realizar solicitud a Shopify
    const response = await fetch(cartUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(cartData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response:', errorData);      
      throw new Error(errorData.description || 'Error al agregar al carrito');
    }

    const result = await response.json();
    console.log('Respuesta del carrito:', result);

    // Mensaje de éxito según tipo de operación
    const successMessage = isPreorder ? 
      (paymentType === 'full' ? 
        `Pago total de ${quantity} producto(s) agregado al carrito` :
        `Apartado de ${quantity} producto(s) agregado al carrito`) :
      `${quantity} producto(s) agregado al carrito`;

    this.showMessage(successMessage, 'success');
    
    // Actualizar el mini carrito
    document.dispatchEvent(new CustomEvent('cart:updated', { 
      detail: { 
        cart: result,
        addedItems: [{
          variantId: selectedVariant.id,
          quantity,
          properties: cartProperties
        }]
      } 
    }));

  } catch (error) {
    console.error('Error al agregar al carrito:', error);
    this.showMessage(error.message || 'Error al agregar al carrito', 'error');
  } finally {
    this.setButtonLoading(button, false);
  }
}

  setButtonLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    
    if (isLoading) {
      button.dataset.originalText = button.textContent;
      button.textContent = 'Agregando...';
    } else {
      button.textContent = button.dataset.originalText;
      delete button.dataset.originalText;
    }
  }

  showMessage(message, type = 'success') {
    const messageElement = document.createElement('div');
    messageElement.className = `cart-message cart-message-${type}`;
    messageElement.innerHTML = `
      <div class="message-content">
        <span class="message-icon">${type === 'success' ? '✓' : '✕'}</span>
        <span class="message-text">${message}</span>
      </div>
    `;
    
    document.body.appendChild(messageElement);
    
    // Agregar clase para la animación de entrada
    requestAnimationFrame(() => {
      messageElement.classList.add('show');
    });
    
    setTimeout(() => {
      messageElement.classList.remove('show');
      setTimeout(() => messageElement.remove(), 300);
    }, 3000);
  }

  formatMoney(amount) {
    return `$${parseFloat(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  }
}
    // Tabs
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = button.getAttribute('data-tab-target');
      
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));
      
      button.classList.add('active');
      document.getElementById(targetId)?.classList.add('active');
    });
  });

// Estilos para los mensajes
const style = document.createElement('style');
style.textContent = `
  .cart-message {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    transform: translateX(120%);
    transition: transform 0.3s ease-in-out;
  }

  .cart-message.show {
    transform: translateX(0);
  }

  .message-content {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    animation: slideIn 0.3s ease-out;
  }

  .cart-message-success .message-content {
    background-color: #4caf50;
    color: white;
  }

  .cart-message-error .message-content {
    background-color: #f44336;
    color: white;
  }

  .message-icon {
    font-size: 18px;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .product-button.loading {
    opacity: 0.7;
    cursor: wait;
  }

  @media (max-width: 768px) {
    .cart-message {
      top: auto;
      bottom: 20px;
      right: 50%;
      transform: translate(50%, 120%);
    }

    .cart-message.show {
      transform: translate(50%, 0);
    }
  }
`;

document.head.appendChild(style);

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  try {
    const productPage = new ProductPage();
    window.productPage = productPage; // Para acceso en la consola si es necesario
  } catch (error) {
    console.error('Error al inicializar ProductPage:', error);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosotros"] && !window.DesignMode) return;
  try {
    
// Animaciones al hacer scroll
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  }, {
    threshold: 0.1
  });

  document.querySelectorAll('.value-card, .team-card, .timeline__event').forEach(el => {
    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Product-filters-component"]) return;
  try {
    
class ProductFilters {
  constructor() {
    this.filters = new Set();
    this.activeFilters = {};
    this.init();
  }

  init() {
    this.bindEvents();
    this.initActiveFiltersFromUrl();
  }

  initActiveFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      this.addFilter(key, value);
      
      // Check corresponding checkbox
      const input = document.querySelector(`input[name="${key}"][value="${value}"]`);
      if (input) {
        input.checked = true;
        input.previousElementSibling.classList.add('checked');
      }
    });
    this.updateActiveFilters();
  }

  bindEvents() {
    // Filter Group Toggle
    document.querySelectorAll('.filter-group-title').forEach(title => {
      title.addEventListener('click', () => {
        const content = title.nextElementSibling;
        content.classList.toggle('active');
      });
    });

    // Filter Checkboxes
    document.querySelectorAll('.filter-option input').forEach(input => {
      input.addEventListener('change', (e) => {
        const checkbox = e.target.previousElementSibling;
        checkbox.classList.toggle('checked');
        
        if (e.target.checked) {
          this.addFilter(e.target.name, e.target.value);
        } else {
          this.removeFilter(e.target.name, e.target.value);
        }
        
        this.updateActiveFilters();
        this.applyFilters();
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.filter-group')) {
        document.querySelectorAll('.filter-group-content').forEach(content => {
          content.classList.remove('active');
        });
      }
    });
  }

  addFilter(type, value) {
    if (!this.activeFilters[type]) {
      this.activeFilters[type] = new Set();
    }
    this.activeFilters[type].add(value);
    this.filters.add(`${type}:${value}`);
  }

  removeFilter(type, value) {
    this.activeFilters[type]?.delete(value);
    if (this.activeFilters[type]?.size === 0) {
      delete this.activeFilters[type];
    }
    this.filters.delete(`${type}:${value}`);
  }

  updateActiveFilters() {
    const container = document.querySelector('.active-filters');
    container.innerHTML = '';

    this.filters.forEach(filter => {
      const [type, value] = filter.split(':');
      const chip = document.createElement('div');
      chip.className = 'active-filter';
      chip.innerHTML = `
        ${this.formatFilterLabel(type, value)}
        <button class="clear-filter" data-filter="${filter}">×</button>
      `;
      container.appendChild(chip);
    });

    this.bindClearButtons();
  }

  formatFilterLabel(type, value) {
    switch(type) {
      case 'price':
        if (value.endsWith('up')) {
          return `$${value.split('-')[0]}+`;
        }
        return `$${value.replace('-', ' - $')}`;
      case 'availability':
        return value === 'in-stock' ? 'In Stock' : 'Out of Stock';
      default:
        return value.replace(/-/g, ' ');
    }
  }

  bindClearButtons() {
    document.querySelectorAll('.clear-filter').forEach(button => {
      button.addEventListener('click', (e) => {
        const filter = e.target.dataset.filter;
        const [type, value] = filter.split(':');
        
        this.removeFilter(type, value);
        
        const input = document.querySelector(`input[name="${type}"][value="${value}"]`);
        if (input) {
          input.checked = false;
          input.previousElementSibling.classList.remove('checked');
        }
        
        this.updateActiveFilters();
        this.applyFilters();
      });
    });
  }

  applyFilters() {
    const params = new URLSearchParams();
    
    Object.entries(this.activeFilters).forEach(([type, values]) => {
      values.forEach(value => {
        params.append(type, value);
      });
    });

    const url = `${window.location.pathname}?${params.toString()}`;
    
    // Disparar evento para actualizar el grid
    const event = new CustomEvent('filtersUpdated', {
      detail: { url }
    });
    document.dispatchEvent(event);
  }
}

// Inicializar los filtros cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new ProductFilters();
});

  } catch(e) { console.error(e); }
})();
})();
